import { ErrorHandler, Injectable, Injector, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FCM } from '@capacitor-community/fcm';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Device } from '@capacitor/device';
import { AlertController, LoadingController, MenuController, ModalController, ToastController } from '@ionic/angular';
import { InAppReview } from '@capacitor-community/in-app-review';
import { EventEmitter } from 'events';
import * as moment from 'moment';
import { BehaviorSubject, EMPTY, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MfaService } from './mfa.service';


import {
  PushNotifications,
} from '@capacitor/push-notifications';

import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { HostListener } from "@angular/core";
import { Platform } from '@ionic/angular';
import { catchError, finalize, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

interface UserProgress {
  title: string
  id: number
}

@Injectable({
  providedIn: 'root'
})

export class DataService implements OnChanges {


  /* Show or hide MQA modal */
  public showMqaModal = false;

  /* Holds the fetched MQA data if present */
  public mqaQuestionnaireData: any = null;

  //global.app.version
  //will be changed by prebuild scipts
  public appversion = "6.126.08";
  public access: any;
  public _basePath: string = environment.apiUrl;
  // public _basePath: string = "https://gap.test/";
  public mainMenu: any = [];
  public pathways: any = [];
  public todo: any = null;
  public timestamp: string;
  public timer: any;
  public diag: any = {}
  public scrollTop: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public exerciseLevel = new EventEmitter();
  public diaryUpdated = new EventEmitter();
  public maintenance_mode: boolean = false;
  public showSpinnerLoader: boolean = false;
  public showSpinnerLoaderTimeout: any;
  public networkConnection: any;
  public dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public ttsMediaPlayer: any;
  public ttsMediaPlayerSources: any = {};
  public displayAppInfo = false;
  public disable_touch_to_speak = '1';
  public gaEvent: any;
  public pnsToken: any;
  public customAlert: any;
  public enable_app_store_rating: any = '0';
  public disable_nhs_login: any = '1';
  public enable_feedback_questionnaire: any = '1';
  public enable_reset_password_page: any = '0';

  public otpcode_exp_time: number = 10 * 60 * 1000; // 10 minutes in milliseconds
  public mfaAuth: MfaService;
  public otpResendDelay: number = 5 * 1000; // 5 seconds

  public createAccountSteps: any = {
    // THERE CAN ALWAYS BE MORE STEPS IN BETWEEN (like verification steps)
    0: "guest", // we click register/create-account
    1: "postcode",
    2: "age-agreement",
    // 2: "select-super-organisation", // we select the super organisation
    // 2: "local-service",
    3: "select-practice", // can have more steps
    // the step where we choose to continue with nhs or getubetter
    4: "choose-registration", // TODO: Create new page
    5: "create-account",
    6: "accesscodes", // means we select the illness or patient affection
    // then feedback input ... etc (but does not matter the first 1-7 matter the most)
    7: "home"
  };

  public loginAccountSteps: any = {
    0: "guest"
  }

  public currentStep = 0;
  public userJourney: 'register' | 'login' = 'login';

  public listing: any = {};

  static visited_nhs_settings?: any = false;

  get isUserLogged(): boolean {
    return localStorage.getItem('isUserLogged') == 'true';
  }

  set isUserLogged(value: boolean) {
    localStorage.setItem('isUserLogged', value.toString());
  }

  get email(): string {
    return this.mfaAuth.email;
  }

  set email(value: string) {
    this.mfaAuth.email = value;
    // Update DataService's user data if necessary
    const user = this.user;
    if (user) {
      user.email = value;
    }
    this.user = user;
  }

  get phone(): string {
    return this.mfaAuth.phone;
  }

  set phone(value: string) {
    this.mfaAuth.phone = value;
    // Update DataService's user data if necessary
    const user = this.user;
    if (user) {
      user.phone = value;
    }
    this.user = user;
  }

  // Getter and setter for mfaFlow
  get mfaFlow(): 'register' | 'login' {
    return this.mfaAuth.mfaFlow;
  }

  set mfaFlow(value: 'register' | 'login') {
    this.mfaAuth.mfaFlow = value;
  }

  get loginResponse(): any {
    const val = this.mfaAuth.loginResponse;
    const storedValue = localStorage.getItem('loginResponse');

    if (storedValue !== null) {
      return JSON.parse(storedValue);
    } else {
      return val;
    }
  }

  set loginResponse(value: any) {
    localStorage.setItem('loginResponse', JSON.stringify(value));
    this.mfaAuth.loginResponse = value;
  }

  get accountMfaVerified(): boolean {
    return this.mfaIsAuthentificated();
  }

  get mqaQuestionnaire(): any {

    // delete after i get it
    const storedValue = localStorage.getItem('mqaQuestionnaire');
    if (storedValue !== null) {
      localStorage.removeItem('mqaQuestionnaire');
      return JSON.parse(storedValue);
    } else {
      return null;
    }
  }

  set mqaQuestionnaire(value: any) {
    localStorage.setItem('mqaQuestionnaire', JSON.stringify(value));
  }

  previousUrl() {
    let history = localStorage.getItem('router_history');
    if (history) {
      history = JSON.parse(history);
      if (history.length > 1) {
        return history[history.length - 2];
      } else {
        return '/fakesplash';
      }
    } else {
      this.logout(false);
      return '/guest';
    }
  }

  navBack(url: string = '') {
    if (url == '') {
      let history = JSON.parse(localStorage.getItem('router_history') || '[]') || [];
        if (history.length > 1) {
          url = history[history.length - 2];
          // remove the last url from history
          history.pop();
          history.pop();
          localStorage.setItem('router_history', JSON.stringify(history));
        } else {
          this.logout(false);
          url = '/guest';
        }
    } else {
      if (url.includes('guest')) {
        this.logout(false);
      }
      if (url.includes('postcode-entry')) {
        // delete the router history and add guest
        localStorage.setItem('router_history', JSON.stringify(['/guest']));
      }
    }
    this.router.navigateByUrl(url, { replaceUrl: true });
  }


  platformWidth() {
    if (!(this.platform.is('android') || this.platform.is('ios')))
      return 640;
    else
      return 320
  }

  platformHeight() {
    if (!(this.platform.is('android') || this.platform.is('ios')))
      return 320;
    else
      return 240
  }

  getVimeoID(video): string {
    return 'vimeo-player-' + video.vimeovideo.replace('/', '');
  }

  vimeowidth(video) {
    let ratio = video.width / video.height;

    return this.platformWidth();
  }

  vimeoheight(video) {
    if (video.height == 0) {
      return 240;
    }
    const aspectRatio = video.width / video.height;
    return this.platformWidth() / aspectRatio;
  }

  vimeolink(video) {
    if (video.vimeovideo)
      return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video' + video.vimeovideo);
    else
      return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/407508746');
  }

  private predefinedProtectedRoutes(): string[] {
    return [
      '/home',
      '/diary',
      '/feedback',
      '/feedbackinput',
      '/recoverytimeline',
      '/accesscodes',
    ];
  }

  verifyIfRouteIsUnderMfa(routePath): boolean {
    const isRoute = this.predefinedProtectedRoutes().includes(routePath);
    if (isRoute && (this.enable_login_mfa == '1' || this.enable_registration_phone_validation == '1')) {
      return true;
    } else {
      return false;
    }
  }


  mfaIsAuthentificated(): boolean {
    let storedValue = localStorage.getItem('mfaAuthValidated');
    const phoneValidated = this.user.account_validated || false;
    
    if (this.enable_registration_phone_validation == '0') {
      storedValue = 'true'; // If phone validation is disabled, assume MFA is always validated
    }

    this.mfaAuth.mfaAuthValidated = storedValue === 'true';
    if (storedValue !== null) {
      return JSON.parse(storedValue) ? true : false;
    } else {
      // todo: Implement API call if necessary
      return false;
    }
  }

  generateMfaCode(type: 'phone' | 'email' = 'phone', phone: string): Promise<any> {
    this.mfaAuth.mfaNow();
    return this.apiPostPremise('generateMFA', {
      type: type,
      phone: phone,
      token: this.token,
    });
  }

  // Delegate other MFA methods
  mfaNow(flow: 'register' | 'login' | '' = '') {
    this.mfaAuth.mfaNow(flow);
  }

  mfaValidate(val: boolean = true) {
    if (val === undefined) {
      val = true;
    }
    this.mfaAuth.mfaValidate(val);
  }

  mfaInvalidate() {
    this.mfaAuth.mfaInvalidate();
  }

  @HostListener('window:error', ['$event'])
  handleKeyDown(event: ErrorEvent) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_342_4_342_29_4`,"ErrorEvent"))
    /* eslint-disable */console.log(...oo_oo(`2708840328_343_4_343_22_4`,event))
  }

  constructor(
    public router: Router,
    public http: HttpClient,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public platform: Platform,
    public menuCtrl: MenuController,
    public route: ActivatedRoute,
    public modalController: ModalController,
    public sanitizer: DomSanitizer
  ) {

    localStorage.removeItem('router_history');
    let that = this;
    this.mfaAuth = MfaService.getInstance();  // MfaService Singleton

    platform.ready().then(() => {
      Device.getInfo().then((info: any) => {

        if (info.platform != 'web') {
          this.diag.cordova = info.cordova;
          this.diag.isVirtual = info.isVirtual;
          this.diag.manufacturer = info.manufacturer;
          this.diag.version = info.osVersion;
          this.diag.platform = info.platform;
          this.diag.serial = info.name;
          this.diag.model = info.model;

          App.getInfo().then((info: any) => {
            /* eslint-disable */console.log(...oo_oo(`2708840328_376_12_376_43_4`,'app info: ', info));
            this.diag.getAppName = info.name;
            this.diag.getPackageName = info.id;
            this.diag.getVersionCode = info.build;
            this.diag.getVersionNumber = info.version;
          });

          Device.getId().then((info: any) => {
            this.diag.uuid = info.identifier;
          });
        } else {
          this.diag.cordova = null
          this.diag.isVirtual = null;
          this.diag.manufacturer = null;
          this.diag.version = null;
          this.diag.platform = null;
          this.diag.serial = null;
          this.diag.model = null;
          this.diag.getAppName = null;
          this.diag.getPackageName = null;
          this.diag.getVersionCode = null;
          this.diag.getVersionNumber = null;
        }
      });

      // this.version.getVersionNumber().then((e:any) => this.diag.getVersionNumber = e).catch((e:any) => this.diag.getVersionNumber = e)
      /* eslint-disable */console.log(...oo_oo(`2708840328_402_6_402_26_4`,'ready'))
      /* eslint-disable */console.log(...oo_oo(`2708840328_403_6_403_23_4`,this))

    });

    this.router.events.subscribe((event) => {
      // When the user navigates to a new page, store the URL in the routerHistory array
      if (event instanceof NavigationEnd) {
        that.routerHistory = event.url;
        this.setUserSteps(event.url);

        if (event.url == '/home') {
          setTimeout(async () => {
            await this.fetchMqaQuestionnaire();
          }, 2000);
        }
        if (event.url != '/') {

          this.setEventsAnalytics(event.url, 'pageview').then((response: any) => {
            if (response.user != undefined && response.user.display_nhs_found_popup != undefined && event.url == '/home') {
              that.presentAlertActions('NHS Number found', 'Your GP Practice will now be updated on the progress of your condition.', [{
                text: 'Ok',
                handler: () => {
                  that.setUserSettings([
                    {
                      nhs_notification_displayed: '1',
                      nhs_notification_displayed_date: moment().format('YYYY-MM-DD H:mm:ss')
                    }
                  ]);
                }
              }]);
            }
            if (response.user != undefined && ((response.user.nhs_status != undefined && response.user.nhs_status != 'found') || (event.url == '/accountdetails'))) {
              let cloneUser = JSON.parse(JSON.stringify(that.user));
              cloneUser.nhs_status = response.user.nhs_status;
              if (response.user.nhs_action != undefined) {
                cloneUser.nhs_action = response.user.nhs_action;
              } else if (cloneUser.nhs_action != undefined) {
                delete cloneUser.nhs_action;
              }
              that.user = cloneUser;
            }
          })
        }
        this.setSession();
      }

      // When the user navigates to a new page, store the URL in the routerHistory array
      if (event instanceof NavigationStart) {
        that.stopTTSMedia();
        /* eslint-disable */console.log(...oo_oo(`2708840328_452_8_452_30_4`,event.url));

        // check if the user routes that are under dome
        if (this.verifyIfRouteIsUnderMfa(event.url) && !this.mfaIsAuthentificated()) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_456_10_456_51_4`,'mfa is not authentificated'));
          this.logout(false);
          this.router.navigate(['guest'], { replaceUrl: true });
        }

        if (that.pathway != undefined && that.pathway.show_timeline_page == 0 && event.url == '/recoverytimeline') {
          that.router.navigateByUrl('/home');
        }
        if (that.pathway != undefined && that.pathway.show_traffic_light_page == 0 && event.url == '/feedbackinput') {
          that.router.navigateByUrl('/home');
        }
      }
      // console.log(event);
    });
  }

  // Method to update phone during registration
  updatePhone(newPhone: string): Promise<any> {
    return this.apiPostPremise('updatePhone', {
      phone: newPhone,
      token: this.token,
    }).then((response: any) => {
      if (response.status === 'success') {
        this.phone = newPhone;
        return response;
      } else {
        return Promise.reject(response);
      }
    });
  }

  public scrollToTop() {
    /* eslint-disable */console.log(...oo_oo(`2708840328_488_4_488_30_4`,"scrollToTop"))
    this.scrollTop.next(true);
  }

  ngOnChanges(changes) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_493_4_493_38_4`,"DataService changes"))
    /* eslint-disable */console.log(...oo_oo(`2708840328_494_4_494_24_4`,changes))
  }

  firstAppOpen() {
    if (!localStorage.getItem('first_app_open')) {
      this.setEventsAnalytics('firstAppOpen', 'event');
      localStorage.setItem('first_app_open', '' + new Date().getTime());
    }
  }

  setSession() {
    if (this.isUserLogged) {
      let session_start: any = localStorage.getItem('session_start');
      if (!session_start || (Math.abs(new Date().getTime() - session_start) / 36e5 > 1)) {
        this.setEventsAnalytics('session_start', 'event');
      }
      localStorage.setItem('session_start', '' + new Date().getTime());
    }
  }

  // LOCKOUT FUNCTIONALITY

  loadUserStatus() {
    // Fetch user status from backend
    this.http.get('/api/user/status').subscribe((status: any) => {
      this.user.islocked_out = status.islocked_out;
      if (this.user.islocked_out) {
        // Handle redirection if necessary
      }
    });
  }

  // Check if the user is locked out
  checkLockoutStatus() {
    if ((this.pathway?.every_days ?? 1) > 0) {
      /* eslint-disable */console.log(...oo_oo(`2708840328_529_6_529_44_4`,'checking lockout status'));
    }
  }

  // Set lockout status
  setLockout(status: boolean) {
    this.user.islocked_out = status;
    // Optionally, persist this status in storage
    this.http.post('/api/user/lockout', { islocked_out: status }).subscribe();

    localStorage.setItem('islocked_out', JSON.stringify(status));
  }

  lockoutGuard() {
    if (this.user?.islocked_out) {
      this.router.navigate(['/access-denied'], { replaceUrl: true });
      return false;
    }
    return true;
  }

  // Check if questionnaire was completed today
  isQuestionnaireCompletedToday(questionnaire_id: number | null | undefined = null): boolean {
    const lastCompleted = localStorage.getItem('last_questionnaire_date_q_id' + (questionnaire_id ?? this.treatment.introquestionnaire.id));
    if (lastCompleted) {
      const today = new Date().toISOString().split('T')[0];
      return lastCompleted === today;
    }
    return false;
  }

  // Mark questionnaire as completed today
  markQuestionnaireCompleted(questionnaire_id: number | null | undefined = null) {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem('last_questionnaire_date_q_id' + (questionnaire_id ?? this.treatment.introquestionnaire.id), today);
  }

  addDaysToday(numberOfDaysToAdd: number | string = 0) {
    const date = new Date();
    const daysToAdd = typeof numberOfDaysToAdd === 'string' ? parseInt(numberOfDaysToAdd, 10) : numberOfDaysToAdd;
    if (daysToAdd) {
      date.setDate(date.getDate() + daysToAdd);
    }

    if (this.user?.id && this.pathway?.id) {
      localStorage.setItem(`today_user_id_${this.user.id}_pathway_id_${this.pathway.id}`,
        date.toISOString().split('T')[0]);
    } else {
      /* eslint-disable */console.error(...oo_tx(`2708840328_577_6_577_52_11`,'User or pathway is undefined.'));
    }

    // set timeout to restore this value to today after 24 hours
    setTimeout(() => {
      this.today = new Date().toISOString().split('T')[0];
    }, this.timeUntilMidnight());

  }

  timeUntilMidnight() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime() - now.getTime();
  }

  get today(): string {
    let key = 'today_user_id_' + this.user.id + '_pathway_id_' + this.pathway.id;
    let today = localStorage.getItem('today_user_id_' + this.user.id + '_pathway_id_' + this.pathway.id);
    if (!today) {
      today = new Date().toISOString().split('T')[0];
      localStorage.setItem('today_user_id_' + this.user.id + '_pathway_id_' + this.pathway.id, today);
    }
    //reset today to today after 24 hours
    setTimeout(() => {
      localStorage.removeItem(key);
    }, this.timeUntilMidnight());

    /* eslint-disable */console.log(...oo_oo(`2708840328_606_4_606_35_4`,'today is:', today));
    return today;
  }

  set today(value: string) {
    localStorage.setItem('today_user_id_' + this.user.id + '_pathway_id_' + this.pathway.id, new Date(value).toISOString().split('T')[0]);
  }

  public clearAllKeysWithPrefixes(prefixes: string[] = []): Promise<void> {
    prefixes = prefixes.length ? prefixes : ['mqaLastFetchAt', 'mqaSubmissionTimestamp', 'mqaQuestionnaireData'];

    return new Promise((resolve, reject) => {
      const keysToRemove: string[] = [];

      // Collect all matching keys first
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && prefixes.some(prefix => key.startsWith(prefix))) {
          keysToRemove.push(key);
        }
      }

      // Remove collected keys
      keysToRemove.forEach(key => localStorage.removeItem(key));
    });
  }

  public getMqaFetchDataKey(): string {
    return 'mqaQuestionnaireData_user_id_' + this.user.id + '_pathway_id_' + this.pathway.id;
  }

  private hasMqaBeenFetched(): boolean {
    const key = 'mqaLastFetchAt' + this.user.id + '-' + this.pathway?.id;
    const fetchedAtStr = JSON.parse(localStorage.getItem(key));

    if (!fetchedAtStr) {
      return false;
    }
    const diff = Date.now() - fetchedAtStr;

    setTimeout(() => {
      localStorage.removeItem(key);
    }, (60000 * 60 * 8) + 5000); // 8 hours);

    // Return true only if less than 20 minutes have passed
    const result = diff < 60000 * 60 * 8;
    return result;
  }

  private setMqaFetched(value: boolean): void {
    const key = 'mqaLastFetchAt' + this.user.id + '-' + this.pathway?.id;

    if (!value) {
      localStorage.removeItem(key);
      return;
    }
    const now = Date.now();
    localStorage.setItem(key, JSON.stringify(now));
  }

  fetchMqaQuestionnaire() {
    // console.log('today is (changedday):', this.today);
    // console.log('showMqaModal:', this.showMqaModal);
    // console.log('hasMqaBeenFetched:', this.hasMqaBeenFetched());
    // console.log('enable_feedback_questionnaire:', this.enable_feedback_questionnaire);

    if (this.enable_feedback_questionnaire == '0') {
      return;
    }

    if (this.showMqaModal ||
      !this.pathway?.id ||
      // this.hasMqaBeenSubmitted() ||
      this.hasMqaBeenFetched()
    ) {
      return;
    }

    /* eslint-disable */console.log(...oo_oo(`2708840328_684_4_684_36_4`,'Fetching MQA data'));
    this.setMqaFetched(true);

    try {
      this.httpPost('feedbackQuestionnaire').then((response: any) => {
        if (response?.questions?.length) {
          localStorage.setItem(this.getMqaFetchDataKey(), JSON.stringify(response));
          this.mqaQuestionnaireData = response;
          this.showMqaModal = true;
        }
      }, (err) => {
        /* eslint-disable */console.error(...oo_tx(`2708840328_695_8_695_53_11`,'Error fetching MQA data', err));
      });
    } catch (error) {
      /* eslint-disable */console.error(...oo_tx(`2708840328_698_6_698_54_11`,'Error fetching MQA data:', error));
    }
  }

  isToday(timestamp: string | null = null, key: string | null = null): boolean {
    if (!timestamp) {
      return new Date().toISOString().split('T')[0] === this.today;
    }
    const date1 = new Date(+timestamp);
    const date2 = new Date(this.today);
    const sameDay = date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
    if (!sameDay && key) {
      localStorage.removeItem(key);
    }
    return sameDay;
  }

  onMqaCompleted(event: any) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_718_4_718_41_4`,'onMqaCompleted:', event));
    if (event.success) {
      this.showMqaModal = false;
      localStorage.removeItem(this.getMqaFetchDataKey());
    } else {
      this.showMqaModal = false;
    }

    setTimeout(() => {
      this.clearAllKeysWithPrefixes(['mqaLastFetchAt', 'mqaSubmissionTimestamp', 'mqaQuestionnaireData']);
    }, this.timeUntilMidnight());
  }

  get isDesktop(): boolean {
    return this.platform.is('desktop');
  }

  get isMobile(): boolean {
    return this.platform.is('mobile');
  }

  set recovery(recovery: any) {
    this.day = recovery.day;
    this.day_message = recovery.day_message
    this.timelineIntervals = recovery.timelineintervals;
    this.progress = recovery.progress;
    this.gateway = recovery.gateway;
    this.painscore = recovery.painscore; // to ask GUB
    this.treatment = recovery.treatment;
    this.worse3times = recovery.worse3times;
    this.aim = recovery.aim;
    this.last_progress = recovery.last_progress;
  }

  get last_progress(): any {
    try {
      return JSON.parse(localStorage.getItem('last_progress'));
    } catch (err) { return false }
  }

  set enable_login_mfa(value) {
    localStorage.setItem('enable_login_mfa', value);
  }

  get enable_login_mfa() {
    //delete all localstorage and return true
    // localStorage.clear();
    if (window.location.hostname === 'localhost' && (window.location.port >= '8100' && window.location.port <= '8110')) {
      return '1';
    }

    return localStorage.getItem('enable_login_mfa');
  }

  set enable_registration_phone_validation(value) {
    localStorage.setItem('enable_registration_phone_validation', value);
  }

  get enable_registration_phone_validation() {
    return localStorage.getItem('enable_registration_phone_validation');
  }

  set last_progress(last_progress) {
    if (!last_progress) {
      /* eslint-disable */console.log(...oo_oo(`2708840328_782_6_782_32_4`,this.recovery));
      throwError('no last progress');
    }
    localStorage.setItem('last_progress', JSON.stringify(last_progress));
  }

  get timeline(): any {
    return JSON.parse(localStorage.getItem('active_timeline'));
  }

  get appointments(): any {
    try {
      return JSON.parse(localStorage.getItem('appointments'));
    } catch (Ex) {
      return {};
    }
  }

  get guest_id() {
    let val: any = localStorage.getItem('guest_id');
    if (!val) {
      val = Date.now();
      this.guest_id = val;
    }
    return val;
  }

  set guest_id(val) {
    localStorage.setItem('guest_id', val);
  }

  get hideNhsNumberPopup() {
    return localStorage.getItem('hide_nhs_number_popup');
  }

  set hideNhsNumberPopup(value: any) {
    localStorage.setItem('hide_nhs_number_popup', value);
  }

  get userttslanguages(): any {
    return JSON.parse(localStorage.getItem('userttslanguages'));
  }

  set userttslanguages(userttslanguages) {
    localStorage.setItem('userttslanguages', JSON.stringify(userttslanguages))
  }

  get showAjaxRequestLoader(): boolean {
    let showAjaxRequestLoaderValue = localStorage.getItem('showAjaxRequestLoader');
    return showAjaxRequestLoaderValue == 'yes' ? true : false;
  }

  set showAjaxRequestLoader(value) {
    clearTimeout(this.showSpinnerLoaderTimeout);
    if (value == true) {
      this.showSpinnerLoaderTimeout = setTimeout(() => {
        this.showSpinnerLoader = value;
      }, 5000);
    } else {
      this.showSpinnerLoader = false;
    }

    localStorage.setItem('showAjaxRequestLoader', value == true ? 'yes' : 'no');
  }

  set appointments(appointments: any) {
    localStorage.setItem('appointments', JSON.stringify(appointments))
  }

  get worse3times(): any {
    try {
      return JSON.parse(localStorage.getItem('worse3times'));
    } catch (Ex) {
      return {};
    }
  }

  set services(worse3times: any) {
    localStorage.setItem('services', JSON.stringify(worse3times))
  }

  get services(): any {
    try {
      return JSON.parse(localStorage.getItem('services'));
    } catch (Ex) {
      return [];
    }
  }

  set worse3times(worse3times: any) {
    localStorage.setItem('worse3times', JSON.stringify(worse3times))
  }

  get colors(): any {
    try {
      return JSON.parse(localStorage.getItem('colors'));
    } catch (Ex) {
      return {};
    }
  }

  set colors(colors: any) {
    localStorage.setItem('colors', JSON.stringify(colors))
  }

  get menu(): any {
    try {
      return JSON.parse(localStorage.getItem('menu'));
    } catch (Ex) {
      return [];
    }
  }

  set menu(menu: any) {
    localStorage.setItem('menu', JSON.stringify(menu))
  }

  get letters(): any {
    try {
      return JSON.parse(localStorage.getItem('letters'));
    } catch (Ex) {
      return [];
    }
  }
  set letters(letters: any) {
    if (letters)
      localStorage.setItem('letters', JSON.stringify(letters))
  }

  get diary(): any {
    try {
      return JSON.parse(localStorage.getItem('diary'));
    } catch (Ex) {
      return [];
    }
  }

  set diary(diary: any) {
    if (diary)
      localStorage.setItem('diary', JSON.stringify(diary))
  }

  get diaryDraft(): any {
    try {
      return JSON.parse(localStorage.getItem('diaryDraft'));
    } catch (Ex) {
      return [];
    }
  }

  set diaryDraft(diaryDraft: any) {
    localStorage.setItem('diaryDraft', JSON.stringify(diaryDraft))
  }

  get basePath(): any {
    // destroy the cache
    if (environment.apiUrl === 'https://getubetter.test/') {
      return 'https://getubetter.test/';
    }

    return JSON.parse(localStorage.getItem('basePath')) ? JSON.parse(localStorage.getItem('basePath')) : this._basePath;
  }

  set basePath(basePath: any) {
    localStorage.setItem('basePath', JSON.stringify(basePath))
  }

  get fontSize(): any {
    try {
      let size = JSON.parse(localStorage.getItem('fontSize')) ?? 3;
      return size ? size : 3;
    } catch (Ex) {
      console.warn(Ex)
      return 3;
    }
  }
  set fontSize(fontSize: any) {
    localStorage.setItem('fontSize', JSON.stringify(fontSize))
  }
  get fontSizeClass(): string {
    if (this.fontSize == 3)
      return '';
    else
      return 'fontSizeClass' + this.fontSize;
  }
  set fontSizeClass(fontSizeClass: string) {
    localStorage.setItem('fontSizeClass', JSON.stringify(fontSizeClass))
  }
  get treatment(): any {
    return JSON.parse(localStorage.getItem('treatment'));
  }
  set treatment(treatment: any) {
    localStorage.setItem('treatment', JSON.stringify(treatment))
  }
  get painscore(): any {
    return JSON.parse(localStorage.getItem('painscore'));
  }
  set painscore(painscore: any) {
    localStorage.setItem('painscore', JSON.stringify(painscore))
  }
  get feedbackzone(): any {
    return JSON.parse(localStorage.getItem('feedbackzone'));
  }
  set feedbackzone(feedbackzone: any) {
    localStorage.setItem('feedbackzone', JSON.stringify(feedbackzone))
  }
  get boxes(): any {
    return JSON.parse(localStorage.getItem('boxes'));
  }
  set boxes(boxes: any) {
    localStorage.setItem('boxes', JSON.stringify(boxes))
  }
  get helpsections(): any {
    return JSON.parse(localStorage.getItem('helpsections'));
  }
  set helpsections(helpsections: any) {
    localStorage.setItem('helpsections', JSON.stringify(helpsections))
  }
  get endpoint(): any {
    return JSON.parse(localStorage.getItem('endpoint'));
  }
  set endpoint(endpoint: any) {
    localStorage.setItem('endpoint', JSON.stringify(endpoint))
  }

  get infozones(): any {
    return JSON.parse(localStorage.getItem('infozones'));
  }
  set infozones(infozones: any) {
    localStorage.setItem('infozones', JSON.stringify(infozones))
  }

  get day(): any {
    return JSON.parse(localStorage.getItem('day'));
  }
  set day(day: any) {
    localStorage.setItem('day', JSON.stringify(day))
  }

  // get intro(): any {
  //   return JSON.parse(localStorage.getItem('intro'));
  // }
  // set intro(intro:any){
  //   localStorage.setItem('intro',JSON.stringify(intro))
  // }

  get gateway(): any {
    return JSON.parse(localStorage.getItem('gateway'));
  }
  set gateway(gateway: any) {
    localStorage.setItem('gateway', JSON.stringify(gateway))
  }

  get day_message(): any {
    return JSON.parse(localStorage.getItem('day_message'));
  }
  set day_message(day_message: any) {
    localStorage.setItem('day_message', JSON.stringify(day_message))
  }

  get pathway(): any {
    return JSON.parse(localStorage.getItem('pathway'));
  }
  set pathway(p: any) {
    localStorage.setItem('pathway', JSON.stringify(p))
  }

  get gp(): any {
    try {
      return JSON.parse(localStorage.getItem('gp'));
    } catch (e) {
      return false;
    }
  }
  set gp(gp: any) {
    localStorage.setItem('gp', JSON.stringify(gp))
  }

  get user(): any {
    return JSON.parse(localStorage.getItem('user'));
  }

  set user(u: any) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1065_4_1065_31_4`,'setting user'));
    /* eslint-disable */console.log(...oo_oo(`2708840328_1066_4_1066_18_4`,u));
    localStorage.setItem('user', JSON.stringify(u))
  }


  get nhsLoggedInStatus(): boolean {
    // get from user.nhs_status
    return this.user.login_service == 'nhs';
  }

  set nhsLoggedInStatus(value: boolean) {
    this.user.login_service = value ? 'nhs' : 'gap';
  }

  get nhsToken(): any {
    return JSON.parse(localStorage.getItem('nhs-token'));
  }

  set nhsToken(u: any) {
    localStorage.setItem('nhs-token', JSON.stringify(u))
  }

  get token(): any {
    return JSON.parse(localStorage.getItem('token'));
  }
  set token(u: any) {
    localStorage.setItem('token', JSON.stringify(u))
  }

  get progress(): any {
    return JSON.parse(localStorage.getItem('progress'));
  }

  get avatar(): any {
    if (this.user && this.user.avatar)
      return this.user.avatar.path
    else
      return 'assets/avatar.svg'
  }

  get diagnostic(): any {

    return this.diag;

  }

  get programs(): any {
    try {
      return JSON.parse(localStorage.getItem('programs'));
    } catch (Ex) {
      return [];
    }
  }

  set programs(programs: any) {
    localStorage.setItem('programs', JSON.stringify(programs))
  }

  get programproviders(): any {
    try {
      return JSON.parse(localStorage.getItem('programproviders'));
    } catch (Ex) {
      return [];
    }
  }

  set programproviders(programproviders: any) {
    localStorage.setItem('programproviders', JSON.stringify(programproviders))
  }


  get availableprograms(): any {
    try {
      return JSON.parse(localStorage.getItem('availableprograms'));
    } catch (Ex) {
      return [];
    }
  }

  set availableprograms(availableprograms: any) {
    localStorage.setItem('availableprograms', JSON.stringify(availableprograms))
  }

  get aim(): any {
    return JSON.parse(localStorage.getItem('aim'));
  }

  set aim(aim: any) {
    localStorage.setItem('aim', JSON.stringify(aim))
  }

  get currentAimFeedback(): any {
    return JSON.parse(localStorage.getItem('currentAimFeedback'));
  }

  set currentAimFeedback(currentAimFeedback: any) {
    localStorage.setItem('currentAimFeedback', JSON.stringify(currentAimFeedback))
  }

  get painhistory(): any {
    return JSON.parse(localStorage.getItem('painhistory'));
  }

  set painhistory(painhistory: any) {
    localStorage.setItem('painhistory', JSON.stringify(painhistory))
  }

  get pathwaylabels(): any {
    try {
      let ret = JSON.parse(localStorage.getItem('pathwaylabels'));
      if (ret)
        return ret;
      else
        return []
    } catch (Ex) {
      return [];
    }
  }

  set pathwaylabels(pathwaylabels: any) {
    let done = localStorage.setItem('pathwaylabels', JSON.stringify(pathwaylabels));
  }

  sendLogMessage(message: string | Object) {

    // this.http.post(this.basePath + 'api/logmessage', this.logMessage).subscribe({
    //   next: function (response: any) {
    //     console.log('log message sent');
    //   },
    //   error: function (response) {
    //     console.log('error');
    //     console.log(response);
    //   }
    // })
  }

  pathwaylabel(input: any, section: any): any {
    let labels = this.pathwaylabels;
    let found = this.pathwaylabels.find((item) => item.slug == section + '.' + input && item.id != undefined);

    if (found) {
      return found['custom'];
    }
    else {
      let already_added = this.pathwaylabels.find((item) => item.slug == section + '.' + input);
      if (already_added == undefined) {
        labels.push({
          'slug': section + '.' + input,
          'custom': input
        });
        this.pathwaylabels = labels;
      }
      // this.setpathwaylabel(input, section);
      return input;
    }
  }

  setpathwaylabels() {
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      labels: this.pathwaylabels.filter(function (item) { return item.id == undefined; })
    };

    this.http.post(this.basePath + 'api/pathwaylabel', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1233_8_1233_38_4`,'setpathwaylabel'));
        /* eslint-disable */console.log(...oo_oo(`2708840328_1234_8_1234_29_4`,response));
        that.pathwaylabels = response.labels;
      },
      error: function (response) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1238_8_1238_28_4`,'error'));
        //that.presentAlert('Login error', 'Can\'t login', 'OK', 'Error: ' + response.error.error);
        /* eslint-disable */console.log(...oo_oo(`2708840328_1240_8_1240_29_4`,response));
      }
    })
  }

  submitReferralQuestionnaire(questions, type) {
    let that = this;
    let payload = {
      token: this.token,
      pathway_id: this.pathway.id,
      questions: questions,
      type: type
    };
    this.http.post(this.basePath + 'api/referral-questionnaire', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1255_8_1255_38_4`,'setpathwaylabel'));
        that.appointments = response.appointments;
        that.letters = response.letters;
      },
      error: function (response) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1260_8_1260_28_4`,'error'));
        //that.presentAlert('Login error', 'Can\'t login', 'OK', 'Error: ' + response.error.error);
        /* eslint-disable */console.log(...oo_oo(`2708840328_1262_8_1262_29_4`,response));
      }
    })
  }


  observer() {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1269_4_1269_37_4`,"observer arguments"))
    /* eslint-disable */console.log(...oo_oo(`2708840328_1270_4_1270_26_4`,arguments))
  }

  async updateProgress(progress: UserProgress, next: any = null) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1274_4_1274_33_4`,"updateProgress"));
    this.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      progress: progress.id
    };

    let that = this
    const response: any = await this.http.post(this.basePath + 'api/userprogress', this.payloadMiddleware(payload)).toPromise();
    /* eslint-disable */console.log(...oo_oo(`2708840328_1284_4_1284_52_4`,'userprogress response: ', response));
    this.showAjaxRequestLoader = false;
    if (response && response.recovery) {
      this.recovery = response.recovery
      this.endpoint = response.endpoint;
      /* eslint-disable */console.log(...oo_oo(`2708840328_1289_6_1289_38_4`,'userprogress done'));
      this.setEventsAnalytics(progress.title, 'event');
    }

    return response
  }

  @Input()
  set progress(progress: any) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1298_4_1298_35_4`,'setting progress'));
    /* eslint-disable */console.log(...oo_oo(`2708840328_1299_4_1299_25_4`,progress));
    localStorage.setItem('progress', JSON.stringify(progress))
  }

  stopTTSMedia() {
    if (this.ttsMediaPlayer != undefined) {
      this.ttsMediaPlayer.pause();
      this.ttsMediaPlayer.currentTime = 0;
      for (let i in this.ttsMediaPlayerSources) {
        this.ttsMediaPlayerSources[i] = '';
      }
    }
  }

  getPageName(name) {
    name = name && name.indexOf('?') != -1 ? name.split('?')[0] : name;
    if (name) {
      switch (true) {
        case name == '/introslider':
          name = '/introcarousel';
          break;
        case name == '/guest':
          name = '/login_or_create_account';
          break;
        case name == '/postcode-entry':
          name = '/postcode_entry';
          break;
        case name.indexOf('/select-practice/') != -1:
          name = '/' + (name.split('/')[2]) + '_selection';
          break;
        case name == '/select-area':
          name = '/area_selection';
          break;
        case name == '/need-help':
          name = '/helpform';
          break;
        case name == '/welcome':
          name = '/welcome_to_gub'
          break;
        case name == '/accescodes':
          name = '/select_a_condition';
          break;
        case name == '/support-modules':
          name = '/select_a_support_module';
          break;
        case name == '/create-account':
          name = '/details_entry';
          break;
        case name == '/register':
          name = '/credentials_entry'
          break;
        case name == '/welcomequestions':
          name = '/initial_screening';
          break;
        case name == '/accesscodes':
          name = '/select_a_condition';
          break;
      }
    }

    return name;
  }

  setEventsAnalytics(name, type, custom_parameters?, replace_params?) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1363_4_1363_36_4`,'name event:', name));
    name = this.getPageName(name);

    this.gaEvent = { event: { name: name, type: type } };
    if (custom_parameters) {
      this.gaEvent.event['custom_parameters'] = custom_parameters;
    }
    this.gaEvent.event['guest_id'] = this.guest_id + '';
    this.gaEvent.event['currentpage'] = this.getPageName(this.router.url);
    this.gaEvent.event['previouspage'] = this.getPageName(this.routerHistory[this.routerHistory.length - 2]);
    this.gaEvent.event['suborg_id'] = this.gp ? this.gp.id : '';
    this.gaEvent.event['pathway_id'] = this.pathway ? this.pathway.id : '';
    this.gaEvent.event['organisation_id'] = this.gp ? this.gp.organisation_id : '';
    if (name.includes('welcomequestionnaire')) {
      this.gaEvent.event['questionnaire_id'] = this.treatment.introquestionnaire.id ?? localStorage.getItem('welcomequestionnaire_id');
    }

    if (['/initial_screening'].indexOf(name) != -1 && this.treatment != undefined && this.treatment.introquestionnaire != undefined && this.treatment.introquestionnaire.id != undefined) {
      this.gaEvent.event['questionnaire_id'] = this.treatment.introquestionnaire.id ?? localStorage.getItem('questionnaire_id');
      if (!this.gaEvent.event['answer_id']) {
        this.gaEvent.event['answer_id'] = localStorage.getItem('questionnaire_answer_id');
      }
    }

    if (['/unlocked'].indexOf(name) != -1 && localStorage.getItem('questionnaire_answer_id')) {
      this.gaEvent.event['questionnaire_id'] = localStorage.getItem('questionnaire_id');
      this.gaEvent.event['answer_id'] = localStorage.getItem('questionnaire_answer_id');
    }

    if (this.gaEvent.event['questionnaire_id'] == undefined && this.gaEvent.event['answer_id'] == undefined) {

      if (type == 'formSubmission') {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1395_8_1395_84_4`,'questionnaire_id and answer_id are undefined for event:', name));
        this.gaEvent.event['questionnaire_id'] = localStorage.getItem('questionnaire_id');
        this.gaEvent.event['answer_id'] = localStorage.getItem('questionnaire_answer_id');
      }

    }

    if (replace_params) {
      for (let i in replace_params) {
        this.gaEvent.event[i] = replace_params[i];
      }
    }

    setTimeout(() => {
      localStorage.removeItem('questionnaire_id');
      localStorage.removeItem('questionnaire_answer_id');
    }, 1000 * 30); // 30 seconds

    return this.apiPostPremise(this.isUserLogged ? 'userappnav' : 'usernavguest', JSON.parse(JSON.stringify(this.gaEvent)));
  }

  openMenu() {
    this.menuCtrl.open('main');

    /* eslint-disable */console.log(...oo_oo(`2708840328_1419_4_1419_21_4`,this))
  }

  closeMenu() {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1423_4_1423_36_4`,"should close menu"))
    setTimeout(() => {
      this.menuCtrl.close('main');
    }, 500);
  }

  enableMenu(enable: boolean = true) {
    this.menuCtrl.enable(enable, 'main');
  }

  resetPulseTimer(interval: number = 10000) {
    if (!interval)
      clearInterval(this.timer)
    else {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.pulse();
      }, interval)
    }
  }
  apiPost(url: string, payload: any) {
    return this.http.post(url, payload)
  }

  /**
   * Make a POST request to the API (url is automatically prefixed with the base path and transformed to kebab-case)
   * Token and pathway_id are added to the payload automatically
   */
  postApiRequest(url: string, payload: any = false) {
    if (!payload) {
      payload = {};
    }
    return this.apiPostPremise(this.caseTransform(url), payload);
  }

  httpPost(url: string, data: any = false) {

    let payload = !data ? {} : data;
    payload['token'] = payload['token'] == undefined ? this.token : payload['token'];
    payload['pathway_id'] = this.pathway ? this.pathway.id : null;

    let apiUrl = this.basePath + 'api/' + this.caseTransform(url);

    return new Promise((resolve, reject) => {
      this.http.post(apiUrl, this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_1469_10_1469_56_4`,'next post-promise URL: ', apiUrl));
          resolve(response);
        },
        error: function (response) {
          reject(response);
        }
      })
    });
  }

  httpGet(url: string, data: any = false) {
    let payload = !data ? {} : data;
    payload['token'] = payload['token'] == undefined ? this.token : payload['token'];
    payload['pathway_id'] = this.pathway ? this.pathway.id : null;

    let apiUrl = this.basePath + 'api/' + this.caseTransform(url);

    /* eslint-disable */console.log(...oo_oo(`2708840328_1486_4_1486_49_4`,'next get-promise URL: ', apiUrl));

    return new Promise((resolve, reject) => {
      this.http.get(apiUrl, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Token': this?.token ? this.token : null,
          'Pathway': this.pathway ? this.pathway.id : null,
          'Diag': JSON.stringify(this.diag)
        }),
        params: data
      })
        .subscribe({
          next: function (response: any) {
            /* eslint-disable */console.log(...oo_oo(`2708840328_1500_12_1500_57_4`,'next get-promise URL: ', apiUrl));
            resolve(response);
          },
          error: function (response) {
            reject(response);
          }
        })
    });

  }

  /**
   * from PascalCase, camelCase, or snake_case to kebab-case
   */
  caseTransform(input: string, useSnakeCase: boolean = false): string {

    if (useSnakeCase) {
      return input
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2') // PascalCase or camelCase to snake_case
        .replace(/-/g, '_') // kebab-case to snake_case
        .toLowerCase();
    }
    return input
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // PascalCase or camelCase to kebab-case
      .replace(/_/g, '-') // snake_case to kebab-case
      .toLowerCase();
  }

  isDebugHost() {
    const portNumber = parseInt(window.location.port, 10);
    const fullHost = window.location.hostname; // e.g. "sub.domain.tld" or "a.b.domain.tld"
    // Special case for Ionic serve on localhost
    if (fullHost === 'localhost' && portNumber >= 8100 && portNumber <= 8110) {
      return true;
    }
    // Allowed hosts to compare against (subdomain.domain.tld format)
    const allowedHosts = ['gap.test', 'testing.getubetter.com'];
    return allowedHosts.filter(host => fullHost.includes(host)).length > 0;
  }

  apiGet(url, queryParams = {}) {
    let payload = queryParams == undefined ? {} : queryParams;

    payload['token'] = payload['token'] == undefined ? this.token : payload['token'];
    payload['pathway_id'] = this.pathway ? this.pathway.id : null;

    let isDebug = this.isDebugHost();

    return new Promise((resolve, reject) => {
      this.http.get(this.basePath + 'api/' + url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Token': this?.token ? this.token : null,
          'Pathway': this.pathway ? this.pathway.id : null,
          'Diag': JSON.stringify(this.diag)
        }),
        params: payload
      }).subscribe({
        next: function (response: any) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_1559_10_1559_52_4`,'next get-promise URL: ', url));
          resolve(response);
        },
        error: function (response) {
          reject(response);
        }
      })
    });
  }

  /**
 * Make a POST request to the API
 * Token and pathway_id are added to the payload automatically
 */
  apiPostPremise(url, data = {}) {
    let payload = data == undefined ? {} : data;
    payload['token'] = payload['token'] === undefined
      ? (this.token !== undefined && this.token !== null && this.token !== '' ? this.token : null)
      : payload['token'];

    if (url == 'userappnav') {
      payload['webappUrl'] = this.router.url;
    }

    payload['pathway_id'] = (this.pathway && this.pathway.id !== undefined && this.pathway.id !== null)
      ? this.pathway.id
      : null;
    
    let isDebug = this.isDebugHost();

    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/' + url, this.payloadMiddleware(data)).subscribe({
        next: function (response: any) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_1592_10_1592_53_4`,'next post-promise URL: ', url));

          if (url == 'generateMFA' && response?.code) {
            if (isDebug) {
              /* eslint-disable */console.log(...oo_oo(`2708840328_1596_14_1596_67_4`,'MFA code:', response?.code ?? 'No code'));
            }
          }
          resolve(response);
        },
        error: function (response) {
          reject(response);
        }
      })
    })
  }

  payloadMiddleware(payload: any = {}) {
    payload.diag = this.diag
    return payload;
  }

  test(payload: any) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_1614_4_1614_24_4`,payload))
  }

  goToPage(url) {
    this.router.navigate([url]);
  }

  async goToUpdate(title: string = "Please update the app!", subtitle: string = "You will be redirected to the store", force = false) {
    let url = null;
    let that = this;
    /* eslint-disable */console.log(...oo_oo(`2708840328_1624_4_1624_21_4`,this));
    let urlDiag = '';
    let urlUser = '';
    try {
      urlDiag = Object.keys(that.diag).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(that.diag[k]) }).join('&');
      urlUser = Object.keys(that.user).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(that.user[k]) }).join('&');
    } catch (Ex) {

    }
    // if(this.diag.platform == null){
    if (this.diag.platform && this.diag.platform == "ios") {
      url = "https://app.getubetter.com/ios-app-link?type=update&" + urlDiag + "&" + urlUser;
    } else {
      if (this.diag.platform && this.diag.platform == "android")
        url = "https://app.getubetter.com/android-app-link?type=update&" + urlDiag + "&" + urlUser;
    }
    if (url) {

      let buttons = [];
      if (force == false) {
        buttons.push(
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              /* eslint-disable */console.log(...oo_oo(`2708840328_1650_14_1650_49_4`,'Confirm Cancel: blah'));
            }
          }
        );
      }
      buttons.push(
        {
          text: 'Update',
          handler: async () => {
            await Browser.open({ url: url });
          }
        }
      );

      const alert = await this.alertController.create({
        header: title,
        message: subtitle,
        buttons: buttons,
        backdropDismiss: !force
      });
      alert.present();

      return true;
    } else {
      return false;
    }
  }

  login(payload: any, finalizeLogin = true) {
    this.showAjaxRequestLoader = true;
    let that = this;
    payload.diag = this.diag
    payload.guest_id = this.guest_id;
    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/login', this.payloadMiddleware(payload)).subscribe({
        next: (response: any) => {
          /* eslint-disable */console.log(...oo_oo(`2708840328_1686_10_1686_29_4`,'next'));
          if (finalizeLogin) {
            that.finalizeLogin(response);
          }
          resolve(response);
        },
        error: function (response) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_1693_10_1693_30_4`,'error'));
          that.token = '';
          that.user = {};
          that.showAjaxRequestLoader = false;
          // that.presentAlert(response.error.title != undefined ? response.error.title : 'Login error', '', 'OK', response.error.error);
          // console.log(arguments);
          reject(response);
        }
      })
    })
  };

  finalizeLogin(response, nhsLogin = false) {
    this.user = response.user;
    this.token = response.token;
    this.guest_id = response.user.guest_id;
    this.isUserLogged = true;
    this.resetPulseTimer(60000);
    /* eslint-disable */console.log(...oo_oo(`2708840328_1711_4_1711_25_4`,response));
    this.showAjaxRequestLoader = false;
    localStorage.removeItem('registerobject');

    // this.loginInWithNhs(nhsLogin);
  }

  finalizeLoginAndRedirect(response) {
    this.setUserSettings([{ account_validated: 1 }]);

    this.setEventsAnalytics('Login', 'event', { product_zone: 'Account Creation' });

    if (response.user.notification != undefined) {
      this.presentAlert(response.user.notification.title, '', 'OK', response.user.notification.message);
    }

    switch (true) {
      case response.user.account_validated == '0':
        this.router.navigateByUrl('/verify/phone', { replaceUrl: true });
        break;
      case response.user.suborg_id == undefined:
        this.router.navigateByUrl('/postcode-entry' + (response.user.postcode != 'NULL' && response.user.postcode ? '/' + response.user.postcode : ''), { replaceUrl: true });
        break;
      default:
        this.router.navigate(['/accesscodes'], { replaceUrl: true });
        break;
    }
  }

  public refreshUser() {
    return this.apiPostPremise('pulse').then((response: any) => {
      if (response?.user?.length == 0) {
        this.logout();
      } else {
        this.user = response.user;
        this.isUserLogged = true;
      }
      this.showAjaxRequestLoader = false;

    }, (err) => {
      /* eslint-disable */console.error(...oo_tx(`2708840328_1751_6_1751_55_11`,'Error refreshing user data:', err));
      this.logout();
    });
  }

  public checktoken() {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
    };

    this.http.post(this.basePath + 'api/pulse/', this.payloadMiddleware(payload)).subscribe({
      next: (response: any) => {

        /* eslint-disable */console.log(...oo_oo(`2708840328_1766_8_1766_35_4`,'active token'));
        this.user = response.user;
        // this.token = response.token;
        // this.loading.dismiss()
        // this.accesscodes()
        this.router.navigateByUrl('/accesscodes')
        this.resetPulseTimer(60000)
        /* eslint-disable */console.log(...oo_oo(`2708840328_1773_8_1773_29_4`,response));
        // this.initPush()

        // that.recovery = response.recovery
        // that.afterSelectPathway()    
        /* eslint-disable */console.log(...oo_oo(`2708840328_1778_8_1778_29_4`,response));
        that.showAjaxRequestLoader = false;
      },
      error: (response) => {
        that.showAjaxRequestLoader = false;
        /* eslint-disable */console.log(...oo_oo(`2708840328_1783_8_1783_29_4`,response))
      }
    })
  }



  // runRecovery(recovery:any = null){
  //   if(recovery){
  //     this.day_message = recovery.day_message
  //     this.timeline = recovery.timeline
  //     this.progress = this.progress
  //     this.gateway = this.gateway
  //   }
  // }

  registerToken(fcm_token) {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      fcm_token: fcm_token
    };

    this.http.post(this.basePath + 'api/registerfcmoken', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1809_8_1809_36_4`,'registerToken'));
        /* eslint-disable */console.log(...oo_oo(`2708840328_1810_8_1810_29_4`,response));
        that.showAjaxRequestLoader = false;
      },
      error: function (response) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1814_8_1814_28_4`,'error'));
        //that.presentAlert('Login error', 'Can\'t login', 'OK', 'Error: ' + response.error.error);
        /* eslint-disable */console.log(...oo_oo(`2708840328_1816_8_1816_29_4`,response));
        that.showAjaxRequestLoader = false;
      }
    })
  }

  async initPNs() {

    // if(this.diag.platform == "android" && localStorage.getItem('notification_permission_checked') != 'yes'){
    //   const alert = await this.alertController.create({
    //     header: 'Get notifications to support your recovery',
    //     message: 'Receive personlised updates, tips and reminders by selecting \'<strong>allow notifications</strong>\' from your phone settings',
    //     buttons: [
    //       {
    //         text: 'Cancel',
    //         role: 'cancel',
    //         cssClass: 'secondary',
    //         handler: (blah) => {
    //           console.log('Confirm Cancel: blah');
    //           localStorage.setItem('notification_permission_checked','yes');
    //         }
    //       },
    //       {
    //         text: 'Go to settings',
    //         handler: () => {
    //           NativeSettings.openAndroid({
    //             option: AndroidSettings.ApplicationDetails,
    //           });
    //           localStorage.setItem('notification_permission_checked','yes');
    //         }
    //       }
    //     ],
    //     backdropDismiss: false
    //   });
    //   alert.present();
    //  }
    let self = this;
    if (this.diag.platform && this.diag.platform != "web") {
      /* eslint-disable */console.log(...oo_oo(`2708840328_1854_6_1854_51_4`,'this.pnsToken: ', this.pnsToken));
      if (this.pnsToken == undefined) {
        await PushNotifications.addListener('registration', async (token) => {
          console.info('Registration token: ', token.value);
          let realToken: any = token.value;
          if (this.diag.platform == "ios") {
            realToken = (await FCM.getToken()).token;
          }
          /* eslint-disable */console.log(...oo_oo(`2708840328_1862_10_1862_75_4`,'Push registration success, realToken: ' + realToken));
          this.pnsToken = realToken;
          this.registerToken(realToken);
        });

        await PushNotifications.addListener('registrationError', err => {
          /* eslint-disable */console.error(...oo_tx(`2708840328_1868_10_1868_58_11`,'Registration error: ', err.error));
        });

        await PushNotifications.addListener('pushNotificationReceived', notification => {
          if (
            notification.data != undefined &&
            notification.data.scope != undefined &&
            notification.data.scope == 'pft_session_reminder' &&
            self.pathway &&
            self.pathway.condition != undefined &&
            self.router.url != '/pelvic-floor-trainer' &&
            self.router.url != '/pelvic-floor-trainer/success' &&
            self.router.url != '/pelvic-floor-trainer/partial-success?long_done=false' &&
            self.router.url != '/pelvic-floor-trainer/partial-success?long_done=true'
          ) {
            self.presentAlertActions("It's time to start training", 'Here is your reminder to start your Pelvic Floor Exercise session.', [
              {
                text: 'Not now',
                role: 'cancel',
                cssClass: 'secondary',
                handler: (blah) => {
                  /* eslint-disable */console.log(...oo_oo(`2708840328_1889_18_1889_53_4`,'Confirm Cancel: blah'));
                }
              },
              {
                text: 'Start Trainer',
                handler: async () => {
                  if (self.pathway.has_pelvic_floor_trainer == 1) {
                    self.router.navigateByUrl('/pelvic-floor-trainer/dashboard');
                  } else {
                    self.router.navigateByUrl('/accesscodes');
                  }
                }
              }
            ]);
          }
        });

        await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
          /* eslint-disable */console.log(...oo_oo(`2708840328_1907_10_1907_107_4`,'Push notification action performed', notification.actionId, notification.inputValue));
        });

        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
          permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
          throw new Error('User denied permissions!');
        }

        await PushNotifications.register();
      } else {
        this.registerToken(this.pnsToken);
      }
    }
  }

  doneGateway(gateway_id) {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      gateway_id: gateway_id
    };

    this.http.post(this.basePath + 'api/donegateway', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1938_8_1938_34_4`,'doneGateway'));
        /* eslint-disable */console.log(...oo_oo(`2708840328_1939_8_1939_29_4`,response));
        that.showAjaxRequestLoader = false;
      },
      error: function (response) {
        /* eslint-disable */console.log(...oo_oo(`2708840328_1943_8_1943_28_4`,'error'));
        //that.presentAlert('Login error', 'Can\'t login', 'OK', 'Error: ' + response.error.error);
        /* eslint-disable */console.log(...oo_oo(`2708840328_1945_8_1945_29_4`,response));
        that.showAjaxRequestLoader = false;
      }
    })

  }

  loadQuestionnaire(id) {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      questionnaire_id: id
    };

    return new Promise((resolve, reject) => {
      that.http.post(that.basePath + 'api/loadquestionnaire/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          // that.recovery = response.recovery
          that.showAjaxRequestLoader = false;
          resolve(response);
          /* eslint-disable */console.log(...oo_oo(`2708840328_1967_10_1967_47_4`,"loadquestionnaire DONE"));
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          reject(response)
        }
      })
    });

  }

  donewelcomequestionnaire(questionnaire) {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      questionnaire_id: questionnaire.id
    };

    return new Promise((resolve, reject) => {
      that.http.post(that.basePath + 'api/donewelcomequestionnaire/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          // that.recovery = response.recovery
          that.showAjaxRequestLoader = false;
          questionnaire = null;
          /* eslint-disable */console.log(...oo_oo(`2708840328_1994_10_1994_45_4`,"refreshrecovery DONE"));
          //that.setEventsAnalytics('Initial screening','formSubmission');
          resolve(response);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          // that.presentAlert('API Warning', ' ', 'OK', response.error.error);
          //that.setEventsAnalytics('Initial screening','formSubmissionError');
          reject(response)
        }
      })
    });
  }

  resetquestionnaire(redirect_to = '/unlocked') {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id
    };

    this.http.post(this.basePath + 'api/resetquestionnaire/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        that.recovery = response.recovery;
        /* eslint-disable */console.log(...oo_oo(`2708840328_2020_8_2020_59_4`,'done reseter from resetquestionnaire'));
        localStorage.setItem('questionnaire_id', response.questionnaire_id);
        localStorage.setItem('questionnaire_answer_id', response.answer_id);

        this.setEventsAnalytics('/unlocked questionnaire reset ', 'formSubmission', { questionnaire_id: response.questionnaire_id, answer_id: response.answer_id, product_zone: 'Questionnaire Reset', pathway_id: that.pathway.id });
        that.router.navigateByUrl(redirect_to);
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  loadProgram(program_id): Promise<any> {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      program_id: program_id
    };

    return new Promise((resolve, reject) => {
      that.http.post(that.basePath + 'api/loadprogram/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          // that.recovery = response.recovery
          that.showAjaxRequestLoader = false;
          resolve(response);
          /* eslint-disable */console.log(...oo_oo(`2708840328_2049_10_2049_45_4`,"refreshrecovery DONE"));
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          reject(response)
        }
      })
    });

  }

  loadGateway(gateway_id): Promise<any> {
    let that = this;
    this.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      gateway_id: gateway_id
    };

    if (this.gateway.questionnaire_type === 'feedback') {
      this.router.navigateByUrl('/home');
    }

    return new Promise((resolve, reject) => {
      that.http.post(that.basePath + 'api/loadgateway/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          // that.recovery = response.recovery
          that.showAjaxRequestLoader = false;
          if (response.gateway.questionnaire_type === 'feedback') {
            that.router.navigateByUrl('/home');
          }
          resolve(response);
          /* eslint-disable */console.log(...oo_oo(`2708840328_2083_10_2083_45_4`,"refreshrecovery DONE"));
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          reject(response)
        }
      })
    });

  }

  selectWorries(active) {
    this.showAjaxRequestLoader = true;
    /* eslint-disable */console.log(...oo_oo(`2708840328_2097_4_2097_23_4`,active))
    let that = this;

    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      active: active
    };

    this.http.post(this.basePath + 'api/selectworries/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        localStorage.setItem('feedbackzone', JSON.stringify(response.feedbackzone))
        that.showAjaxRequestLoader = false;
        that.router.navigateByUrl('/monitorsummary/worries');
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  selectProblems(active) {
    this.showAjaxRequestLoader = true;
    /* eslint-disable */console.log(...oo_oo(`2708840328_2122_4_2122_23_4`,active))
    let that = this;

    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      active: active
    };

    this.http.post(this.basePath + 'api/selectproblems/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        localStorage.setItem('feedbackzone', JSON.stringify(response.feedbackzone))
        that.showAjaxRequestLoader = false;
        that.router.navigateByUrl('/monitorsummary/problems');
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  changeDay(day) {
    this.showAjaxRequestLoader = true;
    let that = this;

    // this.addDaysToday(day);
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      day: day
    };

    this.http.post(this.basePath + 'api/changeday/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.recovery = response.recovery;
        that.showAjaxRequestLoader = false;
        that.presentAlert('Done', 'Recovery day changed', 'OK', '');
        that.router.navigateByUrl('/accesscodes');
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        that.presentAlert('Day change error', 'Can\'t save day', 'OK', response.error.error);
      }
    })
  }

  bookProgram(program, provider) {
    this.showAjaxRequestLoader = true;
    /* eslint-disable */console.log(...oo_oo(`2708840328_2172_4_2172_30_4`,"bookProgram"))
    /* eslint-disable */console.log(...oo_oo(`2708840328_2173_4_2173_24_4`,program))
    /* eslint-disable */console.log(...oo_oo(`2708840328_2174_4_2174_25_4`,provider))
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      program: program,
      provider: provider
    };

    this.http.post(this.basePath + 'api/bookprogram/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.programs = response.programs;
        that.showAjaxRequestLoader = false;
        that.router.navigateByUrl('/home')
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        that.presentAlert('Onboarding error', '', 'OK', response.error.error);
      }
    })
  }

  book(product) {
    this.showAjaxRequestLoader = true;
    /* eslint-disable */console.log(...oo_oo(`2708840328_2198_4_2198_24_4`,product))
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      product: product
    };
    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/bookappointment/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.appointments = response.appointments;
          that.letters = response.letters;
          that.showAjaxRequestLoader = false;
          resolve(response.appointments);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          that.presentAlert(response.error.errorTitle ? response.error.errorTitle : 'Booking error', response.error.errorSubtitle ? response.error.errorSubtitle : '', 'OK', response.error.error);
          reject(response);
        }
      })
    })

  }

  async presentAlert(header: string, subHeader: string, button: string, response: string) {

    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: response,
      buttons: [button]
    });

    await alert.present();
  }

  async presentAlertActions(header: string, subHeader: string, buttons, response: string = '') {

    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: response,
      buttons: buttons,
      backdropDismiss: false
    });

    await alert.present();
  }

  async presentAlertActionsInputs(header: string, subHeader: string, buttons, inputs, response: string = '') {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: response,
      buttons: buttons,
      inputs: inputs,
      backdropDismiss: false
    });

    await alert.present();
  }

  async nhsNumberPopups() {
    /* eslint-disable */console.log(...oo_oo(`2708840328_2262_4_2262_69_4`,'this.hideNhsNumberPopup: ', this.hideNhsNumberPopup));
    if (this.hideNhsNumberPopup == 1) return;
    if (this.user.nhs_status == 'not_found_3_times_inserted') {
      this.presentAlertActions('NHS number not found.', 'Your NHS number could not be found. This means that we cannot update your GP you are using the app.  This will not affect your healthcare.', [{
        text: 'Ok',
        handler: (data) => {
          this.hideNhsNumberPopup = 1;
        }
      }]);

      return;
    }

    if (this.user.nhs_action != undefined) {
      if (this.user.nhs_status != undefined) {
        if (this.user.nhs_status != 'not_found') {
          return;
        }
      }
      let that = this;
      let buttons = [
        {
          text: 'Not now',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            this.hideNhsNumberPopup = 1;
            this.setUserSettings([
              {
                not_now_nhs_popup: '1',
                not_now_nhs_popup_date: moment().format('YYYY-MM-DD H:mm:ss')
              }
            ]);
            this.presentAlert('NHS Number postponed.', 'You can always go to your profile and insert your NHS Number.', 'OK', '');
          }
        },
        {
          text: 'Enter NHS #',
          handler: async () => {
            let buttons2 = [
              {
                text: 'Not now',
                role: 'cancel',
                cssClass: 'secondary',
                handler: (blah) => {
                  this.hideNhsNumberPopup = 1;
                  this.setUserSettings({
                    not_now_nhs_popup: '1',
                    not_now_nhs_popup_date: moment().format('YYYY-MM-DD H:mm:ss')
                  });
                  this.presentAlert('NHS Number postponed.', 'You can always go to your profile and insert your NHS Number.', 'OK', '');
                }
              },
              {
                text: 'Save',
                handler: (data) => {
                  this.setNHSNumber({ temporary_nhs_number: data.temporary_nhs_number });
                }
              }
            ];

            const alertInput = await this.alertController.create({
              header: 'NHS Number',
              subHeader: 'Please type your NHS Number',
              message: '',
              buttons: buttons2,
              inputs: [
                {
                  name: 'temporary_nhs_number',
                  type: 'text'
                }
              ],
              backdropDismiss: false
            });

            await alertInput.present();
          }
        }
      ];
      if (this.user.temporary_nhs_number != undefined && this.user.temporary_nhs_number) {
        this.presentAlertActions('NHS number not found.', 'Your NHS Number ' + this.user.temporary_nhs_number + ' could not be found. Add your NHS number to update your GP', buttons);
      } else {
        this.presentAlertActions('NHS number not found.', '', buttons, 'Your NHS Number based on your name, date of birth and postcode was not found. Add your NHS number to update your GP. <br />If you don\'t know your NHS number, please contact your GP Practice.');
      }
    }
  }

  isLogged() {
    return !!this.token;
  }

  getMenu() {
    return this.mainMenu;
  }

  logMessage(message) {
    // this.http.post(this.basePath + 'api/logmessage', { message: message }).subscribe({
    //   next: function (response: any) {
    //     console.log('logmessage');
    //     console.log(response);
    //   },
    //   error: function (response) {
    //     console.log('error');
    //     console.log(response);
    //   }
    // })
  }

  updateAsymptomaticPathwayProgress() {
    let that = this;
    return new Promise(async (resolve, reject) => {
      let progress: any;
      switch (true) {
        case that.pathway.endpoints.improvingendpoints == true:
          progress = await that.updateProgress({
            title: "improving",
            id: 3
          });
          break;
        case that.pathway.endpoints.thesameendpoints == true:
          progress = await that.updateProgress({
            title: "same",
            id: 2
          });
          break;
        case that.pathway.endpoints.worseendpoints == true:
          progress = await that.updateProgress({
            title: "worse",
            id: 1
          });
          break;
        case that.pathway.endpoints.betterendpoints == true:
          progress = await that.updateProgress({
            title: "better",
            id: 4
          });
          break;
      }

      resolve(progress);
    })
  }

  afterSelectPathway(response) {
    let that = this;
    /* eslint-disable */console.log(...oo_oo(`2708840328_2407_4_2407_47_4`,'this.pathway: ', this.pathway));
    that.recovery = response.recovery;
    /* eslint-disable */console.log(...oo_oo(`2708840328_2409_4_2409_39_4`,'that.day: ', that.day));
    let user_pathways = JSON.parse(localStorage.getItem('user_pathways'));

    if (user_pathways && user_pathways.length == 0) {
      this.setEventsAnalytics('Condition Pathway Added', 'event', { product_zone: 'Screening', pathway_name: this.pathway.condition.name });
    } else {

      if (user_pathways && user_pathways.indexOf(this.pathway.id) == -1) {
        this.setEventsAnalytics('Condition Second Pathway Added', 'event', { product_zone: 'Screening', pathway_name: this.pathway.condition.name });
      }
    }
    localStorage.removeItem('user_pathways');

    if (response.smodules != undefined && response.smodules == true) {
      that.pullAppContent(['smodules']).then((response) => {
        let skip = localStorage.getItem('skip_smodules');
        if (that.availablesmodules && that.availablesmodules.length > 0 && !skip) {
          that.router.navigateByUrl('/support-modules');
        } else {
          that.router.navigateByUrl('/splash');
        }
      });
    } else {
      this.router.navigateByUrl('/splash');
    }
  }

  reinjured() {
    /* eslint-disable */console.log(...oo_oo(`2708840328_2437_4_2437_42_4`,'reinjured called !!!!!!'));
    this.showAjaxRequestLoader = true;
    let that = this;

    let payload = {
      token: this.token,
      pathway: this.pathway.id
    };


    this.http.post(this.basePath + 'api/reinjured/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.recovery = response.recovery;
        that.endpoint = response.endpoint;
        that.showAjaxRequestLoader = false;
        if (response.recovery && response.recovery.day == false)
          that.router.navigateByUrl('/welcomequestions', { replaceUrl: true })
        else
          that.router.navigateByUrl('/welcomequestionnaire', { replaceUrl: true })
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        that.presentAlert('Date set error', 'Can\'t set the date your problem started ', 'OK', response.error.error);
      }
    })
  }

  switchPathway(p: any, related: any) {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: p,
      options: related.options,
      related: related.related
    };

    this.http.post(this.basePath + 'api/switchpathway/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        if (response.pathway)
          that.pathway = response.pathway;
        that.afterSelectPathway(response);
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        this.token = '';
        this.user = {};
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  async selectPathway(p: any) {
    this.showAjaxRequestLoader = true;
    let that = this;

    let payload = {
      token: this.token,
      pathway: p.id,
      suborg_id: p.pivot ? p.pivot.suborg_id : null
    };

    this.http.post(this.basePath + 'api/selectpathway/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.pathway = p;
        that.showAjaxRequestLoader = false;
        that.afterSelectPathway(response);
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  updateUserTTSLanguage(language_id) {
    this.showAjaxRequestLoader = true;
    let self = this;
    let payload = {
      token: this.token,
      language_id: language_id
    };

    return new Promise((resolve, reject) => {
      self.http.post(self.basePath + 'api/updateuserttslanguage/', self.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          self.showAjaxRequestLoader = false;
          let user = self.user;
          user.language_id = language_id;
          self.user = user;
          resolve(response);
        },
        error: function (response) {
          self.showAjaxRequestLoader = false;
          self.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          reject(response)
        }
      })
    })
  }

  testToSpeach(text): Promise<any> {
    this.showAjaxRequestLoader = true;
    let self = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      text: text,
      language_id: this.user.language_id
    };

    return new Promise((resolve, reject) => {
      self.http.post(self.basePath + 'api/getspeachbytext/', self.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          self.showAjaxRequestLoader = false;
          resolve(response);
        },
        error: function (response) {
          self.showAjaxRequestLoader = false;
          self.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          reject(response)
        }
      })
    })
  }

  refreshRecovery(): Promise<any> {
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id
    };

    return new Promise((resolve, reject) => {
      that.http.post(that.basePath + 'api/refreshrecovery/', that.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.recovery = response.recovery;
          resolve(response);
          /* eslint-disable */console.log(...oo_oo(`2708840328_2578_10_2578_45_4`,"refreshrecovery DONE"));
        },
        error: function (response) {
          if (response.error.title != undefined && response.error.title == 'Update available') {
            that.goToUpdate(response.error.title, response.error.subtitle);
          } else {
            that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          }
          reject(response);
        }
      })
    });

  }

  pulse() {
    let that = this;
    if (!this.pathway) {
      this.resetPulseTimer(0)
      return false;
    }

    /* eslint-disable */console.log(...oo_oo(`2708840328_2600_4_2600_28_4`,'run pulse'))
    /* eslint-disable */console.log(...oo_oo(`2708840328_2601_4_2601_32_4`,this.diagnostic))

    let payload = {
      token: this.token,
      data: this.diagnostic,
      pathway: this.pathway ? this.pathway.id : null
    };

    this.http.post(this.basePath + 'api/pulse/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        // that.recovery = response.recovery
        // that.afterSelectPathway()     
        /* eslint-disable */console.log(...oo_oo(`2708840328_2613_8_2613_29_4`,response))
        /* eslint-disable */console.log(...oo_oo(`2708840328_2614_8_2614_32_4`,that.router))
        /* eslint-disable */console.log(...oo_oo(`2708840328_2615_8_2615_31_4`,"^ router"))
      },
      error: (response) => {
        that.showAjaxRequestLoader = false;
        if (response.status == 401) {
          that.resetPulseTimer(0);
          if (that.router.url !== '/guest')
            that.logout();
        }

        if (response.status == 409) {
          // that.presentAlert('Painscore error', 'API request error', 'OK', response.error.error);
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.')
        }
        /* eslint-disable */console.log(...oo_oo(`2708840328_2629_8_2629_29_4`,response))
      }
    })
    return null;
  }

  async updatePainscore(painscore: number) {
    this.showAjaxRequestLoader = true;
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      painscore: painscore
    };

    const response: any = await this.http.post(this.basePath + 'api/selectpainscore/', this.payloadMiddleware(payload))
      .toPromise()
      .catch(function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
        return false;
      })
    that.showAjaxRequestLoader = false;

    return response;
  }

  selectPainscore(painscore: number) {
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      painscore: painscore
    };
    that.showAjaxRequestLoader = true;
    this.http.post(this.basePath + 'api/selectpainscore/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.painscore = painscore;
        that.showAjaxRequestLoader = false;
        that.recovery.painhistory = response.painhistory;
      },
      error: function (response) {
        this.token = '';
        this.user = {};
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  aimFeedback(feedback: number) {
    this.currentAimFeedback = feedback;
    let that = this
    let payload: any = {};
    payload.feedback = feedback;
    payload.token = this.token;
    payload.pathway_id = this.pathway.id;
    payload.pathway = this.pathway.id;

    this.http.post(this.basePath + 'api/aimfeedback/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.recovery = response.recovery
        // that.presentAlert('Thanks for sending your feedback', '', 'OK', 'You can view your aim in "My Diary"');
        // that.router.navigateByUrl('/feedbackzone')
      },
      error: function (response) {
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })

    // this.diaryUpdated.emit("changed")
  }

  setAim(payload: any = {}) {
    let that = this
    payload.token = this.token;
    payload.pathway_id = this.pathway.id;
    payload.pathway = this.pathway.id;

    this.http.post(this.basePath + 'api/aimcreate/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.diary = response.diary;
        that.aim = response.aim;
        that.presentAlert('Thanks for setting an aim', '', 'OK', 'We’ve added it to Your diary');
        that.router.navigateByUrl('/feedbackzone')
      },
      error: function (response) {
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })

    // this.diaryUpdated.emit("changed")
  }

  async diarycreate(note: number, id = false) {
    let that = this;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      note: note,
      id: id
    };

    const response: any = await this.http.post(this.basePath + 'api/diarycreate/', this.payloadMiddleware(payload))
      .toPromise()
      .catch(function (response) {
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
        return false;
      })
    that.diary = response.diary;
    this.diaryUpdated.emit("changed")

    return response;
  }

  async questionnaire(questionnaire: any) {
    let that = this;
    that.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      questionnaire: questionnaire
    };

    const response = await this.http.post(this.basePath + 'api/questionnaire/', this.payloadMiddleware(payload))
      .toPromise()
      .catch(function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
        return false;
      })
    that.showAjaxRequestLoader = false;
    that.pullAppContent(['letters']);
    return response;
  }

  selectWelcome(welcome: any, callback: any = null) {
    let that = this;
    that.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      welcome: welcome
    };

    this.http.post(this.basePath + 'api/selectwelcome/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.recovery = response.recovery
        //check intro questionnaire
        that.pullAppContent();
        if (that.pathway.show_traffic_light_page == 0 && (that.progress == undefined || that.progress.code == undefined)) {
          that.showAjaxRequestLoader = false;
          that.updateAsymptomaticPathwayProgress().then((x) => {
            try {
              /* eslint-disable */console.log(...oo_oo(`2708840328_2788_14_2788_42_4`,'reset welcome'));
              /* eslint-disable */console.log(...oo_oo(`2708840328_2789_14_2789_34_4`,welcome));
              welcome = {
                injured: null,
                injured2nd: null,
                recent_flare: null,
                recurrence: false,
                visited: [false, false, false, false, false, false, false, false]
              };
              // nhs-callback.call()
            } catch (Ex) {
              /* eslint-disable */console.log(...oo_oo(`2708840328_2799_14_2799_29_4`,Ex))
            }
            if (that.treatment && that.treatment.introquestionnaire) {
              that.router.navigateByUrl('/welcomequestionnaire')
            }
            else {
              that.router.navigateByUrl('/recoverytimeline')
            }
          })
        } else {
          try {
            /* eslint-disable */console.log(...oo_oo(`2708840328_2810_12_2810_40_4`,'reset welcome'));
            /* eslint-disable */console.log(...oo_oo(`2708840328_2811_12_2811_32_4`,welcome));
            welcome = {
              injured: null,
              injured2nd: null,
              recent_flare: null,
              recurrence: false,
              visited: [false, false, false, false, false, false, false, false]
            };
            // nhs-callback.call()
          } catch (Ex) {
            /* eslint-disable */console.log(...oo_oo(`2708840328_2821_12_2821_27_4`,Ex))
          }
          if (that.treatment && that.treatment.introquestionnaire) {
            that.router.navigateByUrl('/welcomequestionnaire')
          }
          else {
            that.router.navigateByUrl('/recoverytimeline')
          }
        }
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        this.token = '';
        this.user = {};
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }


  quickWelcome(welcome: any, callback: any = null, callback2nd: any = null, callback3nd: any = null) {
    let that = this;
    if (welcome.injured && typeof welcome.injured == 'object') {
      let injury_date = new Date(welcome.injured.toISOString().split('T')[0]);
      welcome.injured = welcome.injured ? new Date(injury_date.setDate(injury_date.getDate() + 1)).toISOString().split('T')[0] : welcome.injured;
    }
    if (welcome.injured2nd && typeof welcome.injured2nd == 'object') {
      let injured2nd_date = new Date(welcome.injured2nd.toISOString().split('T')[0]);
      welcome.injured2nd = welcome.injured2nd ? new Date(injured2nd_date.setDate(injured2nd_date.getDate() + 1)).toISOString().split('T')[0] : welcome.injured2nd;
    }
    that.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      welcome: welcome
    };

    this.http.post(this.basePath + 'api/selectwelcome/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        that.recovery = response.recovery;
        that.pullAppContent();
        if (that.pathway.show_traffic_light_page == 0 && (that.progress == undefined || that.progress.code == undefined)) {
          that.updateAsymptomaticPathwayProgress().then((x) => {
            callback.call();
          })
        } else {
          callback.call();
        }
        //check intro questionnaire
        // try{
        //   console.log('reset welcome');
        //   console.log(welcome);
        //   welcome = {
        //     injured: null,
        //     recurrence: false,
        //     visited: [false, false, false, false, false, false, false, false]
        //   };

        // }catch(Ex){
        //   console.log(Ex)
        // }
        // if(that.treatment && that.treatment.introquestionnaire){
        //   that.router.navigateByUrl('/welcomequestionnaire')
        // }
        // else
        //   that.router.navigateByUrl('/recoverytimeline')
      },
      error: function (response) {
        // this.token = '';
        // this.user = {};
        that.showAjaxRequestLoader = false;
        /* eslint-disable */console.log(...oo_oo(`2708840328_2894_8_2894_29_4`,response));
        if (response.status == 555)
          callback2nd.call();
        else
          if (response.status != 503) {
            that.presentAlert('Warning', '', 'OK', response.error.error);
            callback3nd.call();
          }
      }
    })
  }

  signup(payload) {
    let that = this;
    that.showAjaxRequestLoader = true;
    payload['phone'] = payload['phone'].replace('+440', '+44');
    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/signup/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.gp = response.gp;
          that.showAjaxRequestLoader = false;
          that.setEventsAnalytics('Register', 'formSubmission', { currentpage: '/register', product_zone: 'Account Creation' });
          resolve(response);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          this.token = '';
          this.user = {};
          // that.presentAlert(errorTitle, '', 'OK', response.error.error);
          reject(response)
        }
      })
    })

  }

  accesscodes(showLoader = true, redirect = true) {
    let that = this;
    that.showAjaxRequestLoader = showLoader;
    let payload = {
      token: this.token
    };

    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/accesscodes/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.showAjaxRequestLoader = false;
          that.pathways = response.pathways;
          localStorage.setItem('user_pathways', JSON.stringify(response.user_pathways));
          if (redirect == true) {
            that.router.navigateByUrl('/accesscodes');
          }
          resolve(response);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          if (response.status != 503)
            that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          reject(response);
        }
      })
    })

  }

  updateProfile(payload: any) {
    let that = this;
    that.showAjaxRequestLoader = true;
    payload.token = this.token;
    payload.pathway = this.pathway.id;

    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/updaterofile/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.showAjaxRequestLoader = false;
          resolve(response);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          if (response.status != 503 && response.status != 400)
            that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
          else reject(response);
        }
      })
    })
  }

  setNHSNumber(payload: any) {
    let that = this;
    that.showAjaxRequestLoader = true;
    payload.token = this.token;

    this.http.post(this.basePath + 'api/setnhsnumber/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        that.user = response.user;
        that.presentAlert('NHS number status', 'Your NHS number is being proccessed.', 'OK', '');
        that.router.navigateByUrl('/home');
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('NHS number error', 'Can\'t update information', 'OK', response.error.error);
      }
    })
  }


  removeLetter(payload: any) {
    let that = this;
    that.showAjaxRequestLoader = true;
    payload.token = this.token;
    payload.pathway = this.pathway.id;

    this.http.post(this.basePath + 'api/removeletter/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        that.letters = response.letters
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Inbox warning', 'Can\'t remove letter', 'OK', response.error.error);
      }
    })
  }

  forgot(email) {
    let that = this;
    that.showAjaxRequestLoader = true;
    let payload = {
      email: email
    };

    return new Promise((resolve, reject) => {
      this.http.post(this.basePath + 'api/forgot/', this.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.showAjaxRequestLoader = false;
          resolve(true);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          reject(response);
        }
      })
    })

  }

  readLetter(payload: any) {
    let that = this;
    payload.token = this.token;
    payload.pathway = this.pathway.id;

    this.http.post(this.basePath + 'api/readletter/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        that.letters = response.letters;
      },
      error: function (response) {
        // that.presentAlert('Inbox warning', 'Can\'t remove letter', 'OK', response.error.error);
      }
    })
    /* eslint-disable */console.log(...oo_oo(`2708840328_3057_4_3057_26_4`,'reading'))
    /* eslint-disable */console.log(...oo_oo(`2708840328_3058_4_3058_24_4`,payload))
  }

  updatePassword(payload: any) {
    let that = this;
    that.showAjaxRequestLoader = true;
    payload.token = this.token;
    payload.pathway = this.pathway.id;

    this.http.post(this.basePath + 'api/updatepassword/', this.payloadMiddleware(payload)).subscribe({
      next: function (response: any) {
        that.showAjaxRequestLoader = false;
        //that.recovery = response.recovery;
        that.user = response.user;
        that.presentAlert('Password updated', '', 'OK', '');
        that.router.navigateByUrl('/home')
      },
      error: function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      }
    })
  }

  async uploadDiaryData(formData: FormData) {

    let that = this
    const loading = await this.loadingController.create({
      message: 'Uploading diary image...',
    });
    await loading.present();

    // this.uploadPhoto(formData);
    formData.append('token', this.token);
    formData.append('pathway', this.pathway.id);

    this.http.post(this.basePath + "api/diarycreate", formData)
      .pipe(
        finalize(() => {
          loading.dismiss();
          this.diaryUpdated.emit("changed")
        })
      )
      .subscribe(res => {
        /* eslint-disable */console.log(...oo_oo(`2708840328_3103_8_3103_24_4`,res))
        if (res['message'] == "Done") {
          // this.user = res.user
          this.diary = res['diary']
          this.router.navigateByUrl('/diary/' + res['note']['id'])
          this.diaryUpdated.emit("changed")

          this.presentToast('File upload complete.')
        } else {
          this.presentToast('File upload failed.')
        }
      });
  }

  async uploadImageData(formData: FormData) {
    let that = this
    const loading = await this.loadingController.create({
      message: 'Uploading image...',
    });
    await loading.present();

    // this.uploadPhoto(formData);
    formData.append('token', this.token);
    formData.append('pathway', this.pathway.id);

    this.http.post(this.basePath + "api/upload", formData)
      .pipe(
        finalize(() => {
          loading.dismiss();
        })
      )
      .subscribe(res => {
        /* eslint-disable */console.log(...oo_oo(`2708840328_3135_8_3135_24_4`,res))
        if (res['message'] == 'Done') {
          // this.user = res.user
          this.user = res['user']
          this.presentToast('File upload complete.')
        } else {
          this.presentToast('File upload failed.')
        }
      });
  }

  async presentToast(text) {
    const toast = await this.toastController.create({
      message: text,
      position: 'bottom',
      duration: 3000
    });
    toast.present();
  }

  async exerciselevel(exercise: any = null, level: any = null) {
    let that = this;
    that.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      exercise: exercise,
      level: level
    };

    const ret: any = await this.http.post(this.basePath + 'api/exerciselevel', this.payloadMiddleware(payload))
      .toPromise()
      .catch(function (response) {
        that.showAjaxRequestLoader = false;
        if (response.status != 503)
          that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
        return false;
      })
    that.showAjaxRequestLoader = false;
    this.endpoint = ret.endpoint;
    this.availablesmodules = ret.smodules.availablesmodules;
    this.smodules = ret.smodules.smodules;
    this.pftsmodules = ret.pftsmodules;
    return ret;

  }

  labels(input: String, section: any) {
    return this.pathwaylabel(input, section);
  }

  get visitedsmpages(): any {
    try {
      let ret = JSON.parse(localStorage.getItem('visitedsmpages'));
      if (ret)
        return ret;
      else
        return []
    } catch (Ex) {
      return [];
    }
  }

  set visitedsmpages(visitedsmpages: any) {
    let done = localStorage.setItem('visitedsmpages', JSON.stringify(visitedsmpages));
  }

  get visitedboxes(): any {
    try {
      let ret = JSON.parse(localStorage.getItem('visitedboxes'));
      if (ret)
        return ret;
      else
        return {}
    } catch (Ex) {
      return {};
    }
  }

  set visitedboxes(visitedboxes: any) {
    let done = localStorage.setItem('visitedboxes', JSON.stringify(visitedboxes));
  }

  async visitbox(module: any = {}, box: any, page: any = {}) {
    let that = this;
    this.showAjaxRequestLoader = true;
    let visitedboxes = this.visitedboxes;
    if (!visitedboxes[module]) {
      visitedboxes[module] = [];
    }
    if (visitedboxes[module].indexOf(box) == -1) {
      visitedboxes[module].push(box);
      this.visitedboxes = visitedboxes;
    }

    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      module_id: module,
      box_id: box,
      visitedboxes: this.visitedboxes,
    };

    const ret = await this.http.post(this.basePath + 'api/boxvisit', this.payloadMiddleware(payload))
      .toPromise()
      .catch((response) => {
        that.showAjaxRequestLoader = false;
        // this.presentAlert('Exercise error', 'Can\'t save exercise level', 'OK', response.error.error);
        return false;
      })
    that.showAjaxRequestLoader = false;
  }

  ismoduleVisited(smodule: any) {
    let ret = this.visitedsmpages.find((item) => item.smpage_id && smodule.pages && smodule.pages.length && smodule.pages[0] && smodule.pages[0].id == item.smpage_id);
    return ret;
  }

  ispageVisited(smpage_id: any) {
    let ret = this.visitedsmpages.find((item) => item.smpage_id == smpage_id);
    return ret;
  }

  isboxVisited(box: any, module: any) {
    if (this.visitedboxes[module] && this.visitedboxes[module].indexOf(box) > -1)
      return true;
    else
      return false;
  }

  get smodules(): any {
    try {
      let ret = JSON.parse(localStorage.getItem('smodules'));
      if (ret)
        return ret;
      else
        return []
    } catch (Ex) {
      return [];
    }
  }

  set smodules(smodules: any) {
    let done = localStorage.setItem('smodules', JSON.stringify(smodules));
  }

  get availablesmodules(): any {
    try {
      let ret = JSON.parse(localStorage.getItem('availablesmodules'));
      if (ret)
        return ret;
      else
        return []
    } catch (Ex) {
      return [];
    }
  }

  setUserSteps(url: String) {
    // set register or login
    // if (!this.user.postcode && url.indexOf('postcode') > -1) {
    //   this.userJourney = 'register';
    // } else if (this.user.postcode && url.indexOf('/login') > -1) {
    //   this.userJourney = 'login';
    // }
    // 

  }

  get routerHistory() {
    let ret = JSON.parse(localStorage.getItem('router_history'));
    return ret ? ret : [];
  }

  set routerHistory(url) {
    let ret = JSON.parse(localStorage.getItem('router_history'));
    if (!ret) {
      ret = [];
    }
    if (ret.length > 5) {
      ret.shift();
    }
    ret.push(url);
    localStorage.setItem('router_history', JSON.stringify(ret));
  }

  set availablesmodules(availablesmodules: any) {
    let done = localStorage.setItem('availablesmodules', JSON.stringify(availablesmodules));
  }

  public listingLog(payload: any = {}) {

    let that = this;
    payload.token = this.token;
    payload.pathway = this.pathway.id;

    this.http.post(this.basePath + 'api/pulse/', this.payloadMiddleware(payload)).subscribe({
      next: (response: any) => {

        /* eslint-disable */console.log(...oo_oo(`2708840328_3334_8_3334_35_4`,'active token'));
        this.user = response.user;
        // this.token = response.token;
        // this.loading.dismiss()
        // this.accesscodes()
        // this.router.navigateByUrl('/accesscodes')
        // this.resetPulseTimer(60000)
        /* eslint-disable */console.log(...oo_oo(`2708840328_3341_8_3341_29_4`,response));
        // this.initPush()

        // that.recovery = response.recovery
        // that.afterSelectPathway()     
        /* eslint-disable */console.log(...oo_oo(`2708840328_3346_8_3346_29_4`,response))
      },
      error: (response) => {
        that.showAjaxRequestLoader = false;
        /* eslint-disable */console.log(...oo_oo(`2708840328_3350_8_3350_29_4`,response))
      }
    })
  }

  bookExternal(listing: any) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_3356_4_3356_24_4`,listing));
    let that = this;
    that.showAjaxRequestLoader = true;
    let payload = {
      token: this.token,
      pathway: this.pathway.id,
      listing_id: listing.id
    };
    payload.token = this.token;
    this.http.post(this.basePath + 'api/externalbook/', this.payloadMiddleware(payload)).subscribe({
      next: async (response: any) => {
        that.showAjaxRequestLoader = false;
        /* eslint-disable */console.log(...oo_oo(`2708840328_3368_8_3368_35_4`,'active token'));
        // this.user = response.user;
        // this.token = response.token;
        // this.loading.dismiss()
        // this.accesscodes()
        // this.router.navigateByUrl('/accesscodes')
        // this.resetPulseTimer(60000)
        if (response.link) {
          await Browser.open({ url: response.link });
        }
        // this.initPush()

        // that.recovery = response.recovery
        // that.afterSelectPathway()     
        /* eslint-disable */console.log(...oo_oo(`2708840328_3382_8_3382_29_4`,response))
      },
      error: (response) => {
        that.showAjaxRequestLoader = false;
        /* eslint-disable */console.log(...oo_oo(`2708840328_3386_8_3386_29_4`,response))
      }
    })
  }

  // get logPayload() {
  //   let message = localStorage.getItem('logPayloadMessage');
  //   if (message) {
  //     return JSON.parse(message);
  //   }

  //   return 'User has not logged anything yet';
  // }

  // set logPayload(message: string|Object) {

  //   let payload = {
  //     token: this.token,
  //     pathway: this?.pathway?.id,
  //     diag: this?.diag,
  //     message: message
  //   };

  //   localStorage.setItem('logPayloadMessage', JSON.stringify(payload));
  // }

  get pftsmodules() {
    return JSON.parse(localStorage.getItem('pftsmodules')) ?? [];
  }

  set pftsmodules(smodules) {
    localStorage.setItem('pftsmodules', JSON.stringify(smodules));
  }

  get timelineIntervals() {
    try {
      return JSON.parse(localStorage.getItem('timelineIntervals'));
    } catch (err) { return [] };
  }

  set timelineIntervals(timelineIntervals) {
    let self = this;
    localStorage.setItem('timelineIntervals', JSON.stringify(timelineIntervals ? timelineIntervals : []));
    let timelineStorage = null;

    if (timelineIntervals && timelineIntervals.length) {
      if (this.pathway.show_traffic_light_page == 0) {
        timelineStorage = timelineIntervals[0];
        timelineStorage['pos'] = 0;
      } else {
        timelineIntervals.forEach((e, i) => {
          if (e.start_day <= self.day && e.end_day >= self.day) {
            timelineStorage = e;
            timelineStorage['pos'] = ++i;
          }
        });
        if (timelineStorage == null) {
          timelineStorage = timelineIntervals[timelineIntervals.length - 1];
          timelineStorage['pos'] = timelineIntervals.length;
        }
      }
    }
    /* eslint-disable */console.log(...oo_oo(`2708840328_3448_4_3448_53_4`,'active_timeline: ', timelineStorage));
    /* eslint-disable */console.log(...oo_oo(`2708840328_3449_4_3449_38_4`,'for day: ', this.day));
    localStorage.setItem('active_timeline', JSON.stringify(timelineStorage));
  }

  pullAppContent(requests = []) {
    let that = this;
    return new Promise((resolve, reject) => {
      let promises = [];
      let setupPathways = false;
      if (requests == undefined || requests.length == 0) {
        requests = ['gp', 'endpoint', 'infozones', 'helpsections', 'boxes', 'feedbackzone', 'services', 'appointments', 'letters', 'menu', 'colors', 'programs', 'smodules', 'programproviders', 'visitedsmpages', 'visitedboxes', 'painhistory', 'diary'];
        if (that.disable_touch_to_speak == '0') {
          requests.push('userttslanguages');
        }
        if (that.pathway != undefined && that.pathway.condition != undefined && that.pathway.has_pelvic_floor_trainer == 1) {
          requests.push('pftsettings');
          requests.push('pftsmodules');
        }
        setupPathways = true;
      }
      for (let request of requests) {
        promises.push(this.apiPostPremise(request))
      }
      Promise.all(promises).then((responses) => {
        for (let pos in responses) {
          switch (true) {
            case requests[pos] == 'smodules':
              localStorage.setItem('smodules', JSON.stringify(responses[pos]['smodules']));
              localStorage.setItem('availablesmodules', JSON.stringify(responses[pos]['availablesmodules']));
              break;
            case requests[pos] == 'pftsettings':
              if (responses[pos].pftsettings) {
                responses[pos].pftsettings.reminder_1 = responses[pos].pftsettings.reminder_1 ? responses[pos].pftsettings.reminder_1.replace('.', ':') : null;
                responses[pos].pftsettings.reminder_2 = responses[pos].pftsettings.reminder_2 ? responses[pos].pftsettings.reminder_2.replace('.', ':') : null;
                responses[pos].pftsettings.reminder_3 = responses[pos].pftsettings.reminder_3 ? responses[pos].pftsettings.reminder_3.replace('.', ':') : null;
                localStorage.setItem(requests[pos], JSON.stringify(responses[pos][requests[pos]]));
              }
              break;
            default:
              localStorage.setItem(requests[pos], JSON.stringify(responses[pos][requests[pos]]));
              break;
          }
        }
        if (setupPathways == true) {
          that.setpathwaylabels();
        }
        resolve(true);
      }, err => {
        that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again later.');
      });
    })

  }

  public async rateApp() {
    // If app store rating is disabled, do nothing
    if (this.enable_app_store_rating == '0') return;
    if (this.enable_app_store_rating == '2' && this.user.debug != 1) return;
    if (this.user.app_store_rate_date != null) return;

    // Check if we've hit the 'Not now' limit (3+ times)
    const notNowCount = parseInt(localStorage.getItem('rate_app_not_now_count') || '0', 10);
    if (notNowCount >= 3) {
      return; // don't show the pop-up again
    }

    // Check if 48 hours have passed since 'last shown'
    const now = Date.now();
    const lastShown = parseInt(localStorage.getItem('rate_app_last_shown') || '0', 10);
    const hoursSinceLast = (now - lastShown) / (1000 * 60 * 60);
    if (lastShown && hoursSinceLast < 48) {
      return; // not yet time to show again
    }

    // Record displaying the pop-up now
    localStorage.setItem('rate_app_last_shown', now.toString());

    // Everything else stays as in your current pop-up code:
    // (Only the ‘Not now’ branch changes to increment the 'Not now' counter.)
    let self = this;
    let alert: any;
    let alert2: any;
    let buttons = [];

    buttons.push({
      text: 'No',
      handler: async () => {
        alert2 = await this.alertController.create({
          header: '',
          message: '<img src="/assets/icon/icon.png" /></br /><h3>We’re sorry to hear that</h3><p>Please help us to improve by leaving feedback</p>',
          cssClass: 'store-rating-no',
          inputs: [{ type: 'textarea', placeholder: 'Type here' }],
          buttons: [
            {
              text: 'Not now',
              handler: () => {
                // Increment 'Not now' count
                const currentCount = parseInt(localStorage.getItem('rate_app_not_now_count') || '0', 10);
                localStorage.setItem('rate_app_not_now_count', (currentCount + 1).toString());
                // Track the time so next pop-up can happen at least 48h later
                localStorage.setItem('rate_app_last_shown', Date.now().toString());

                let now_now = JSON.parse(localStorage.getItem('rate_app_not_now')) ?? [];
                now_now.push(new Date());
                localStorage.setItem('rate_app_not_now', JSON.stringify(now_now));
              }
            },
            {
              text: 'Submit',
              handler: (data) => {
                self.setUserSettings([
                  {
                    app_store_rate_like: 'no',
                    app_store_rate_date: moment().format('YYYY-MM-DD H:mm:ss'),
                    app_store_rate_review: data[0],
                    app_store_rate_screen: self.router.url
                  }
                ]).then(() => {
                  self.presentAlert('Thank you', 'Thank you for your feedback.', 'OK', '');
                });
              }
            }
          ],
          backdropDismiss: false
        });
        alert2.present();
      }
    });

    buttons.push({
      text: 'Yes',
      handler: () => {
        self.setUserSettings([
          {
            app_store_rate_like: 'yes',
            app_store_rate_date: moment().format('YYYY-MM-DD H:mm:ss'),
            app_store_rate_review: '',
            app_store_rate_screen: self.router.url
          }
        ]);
        InAppReview.requestReview();
      }
    });

    alert = await this.alertController.create({
      header: "",
      message: '<h2>Are you enjoying<br />getUBetter?</h2>',
      buttons: buttons,
      backdropDismiss: false,
      cssClass: 'store-rating-no'
    });
    alert.present();
  }

  setUserSettings(settings: any) {
    let that = this;
    that.showAjaxRequestLoader = true;

    return new Promise((resolve, reject) => {
      let payload = {
        token: that.token,
        settings: settings
      }
      that.http.post(that.basePath + 'api/setusersettings/', that.payloadMiddleware(payload)).subscribe({
        next: function (response: any) {
          that.showAjaxRequestLoader = false;
          that.user = response.user;
          resolve(true);
        },
        error: function (response) {
          that.showAjaxRequestLoader = false;
          if (response.status != 503)
            that.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again.');
          reject(response);
        }
      })
    })
  }

  public logout(goToGuest = true) {
    // Clear rate-app counters and timestamps on logout
    localStorage.removeItem('rate_app_not_now_count');
    localStorage.removeItem('rate_app_last_shown');

    // ...existing logout logic...
    Object.keys(localStorage).forEach(data => {
      if (['first_app_open', 'introslider', 'router_history', 'basePath', 'loginResponse', 'token'].indexOf(data) == -1) {
        localStorage.removeItem(data);
      }
    });
    this.mfaAuth.mfaInvalidate();
    this.isUserLogged = false;
    this.resetPulseTimer(0)
    this.enableMenu(false);
    if (goToGuest) {
      this.router.navigateByUrl('/guest', { replaceUrl: true });
    }
  }

  set visitedNhsSettingsPage(set: boolean | string) {
    // DataService.visitedNhsStPage = set;

    DataService.visited_nhs_settings = set;
    // this.storage.set('visited_nhs_settings', set);\
    if (typeof set == 'boolean') {
      localStorage.setItem("going-to-nhs-settings", set.toString());
    } else {
      localStorage.setItem("going-to-nhs-settings", set);
    }
  }

  get visitedNhsSettingsPage() {
    let val = localStorage.getItem("going-to-nhs-settings");

    if (val == null) {
      val = DataService.visited_nhs_settings || false;
    }
    // val = DataService.visited_nhs_settings;
    // if (val == null) {
    //   val = DataService.visitedNhsStPage;
    //   if (val == null) {
    //     val = localStorage.getItem("going-to-nhs-settings") == 'true';
    //     DataService.visitedNhsStPage = val;
    //   }
    // }
    if (typeof val == 'boolean') {
      return val;
    } else {
      return val == 'true'
    }

    return (val === null || val === undefined) ? false : val;
  }

  get nhsAccounts(): string[] {
    // Retrieve the NHS accounts from local storage
    const nhsAccounts = localStorage.getItem('nhs_accounts');
    if (nhsAccounts) {
      try {
        return JSON.parse(nhsAccounts);
      } catch (e) {
        /* eslint-disable */console.error(...oo_tx(`2708840328_3690_8_3690_74_11`,'Error parsing nhs_accounts from local storage:', e));
        return [];
      }
    }
    return [];
  }

  newNmhsAccount(email: string): void {
    // Check if the email is already in the NHS accounts
    const nhsAccounts = this.nhsAccounts;
    if (email && !nhsAccounts.includes(email)) {
      // If not, add it to the NHS accounts
      nhsAccounts.push(email);
      localStorage.setItem('nhs_accounts', JSON.stringify(nhsAccounts));
      /* eslint-disable */console.log(...oo_oo(`2708840328_3704_6_3704_50_4`,'New NHS account added:', email));
    } else {
      /* eslint-disable */console.log(...oo_oo(`2708840328_3706_6_3706_75_4`,'NHS account already exists or email is invalid:', email));
    }
  }

  /**
   * Attach debug helpers to the window for interactive debugging in the browser console.
   * After calling this method, you can use `window.dataServiceDebug` in the console.
   */
  attachDebugHelpers(): void {
    // Expose the DataService instance and useful methods/fields to the window object
    (window as any).dataServiceDebug = {
      service: this,
      user: () => this.user,
      nhsToken: () => this.nhsToken,
      nhsLoggedInStatus: () => this.nhsLoggedInStatus,
      nhsAccounts: () => this.nhsAccounts,
      show: () => {
        /* eslint-disable */console.log(...oo_oo(`2708840328_3723_8_3723_39_4`,'User:', this.user));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3724_8_3724_48_4`,'NHS Token:', this.nhsToken));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3725_8_3725_68_4`,'NHS Logged In Status:', this.nhsLoggedInStatus));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3726_8_3726_54_4`,'NHS Accounts:', this.nhsAccounts));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3727_8_3727_88_4`,'Local Storage NHS Accounts:', localStorage.getItem('nhs_accounts')));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3728_8_3728_68_4`,'User Flow:', localStorage.getItem('user_flow')));
      }
    };
    // Optionally log a message to let the developer know
    /* eslint-disable */console.log(...oo_oo(`2708840328_3732_4_3732_86_4`,'Debug helpers attached. Use window.dataServiceDebug in the console.'));
  }

  setNhsAccounts(emailAcc: string): void {
    const userFlow = localStorage.getItem('user_flow') || 'login';
    const nhsAccounts = JSON.parse(localStorage.getItem('nhs_accounts') || '[]');
    const email = emailAcc;
    /* eslint-disable */console.log(...oo_oo(`2708840328_3739_4_3739_60_4`,'Setting NHS accounts:', email, nhsAccounts));

    // If the current user's email is not in nhsAccounts, add it
    if (email && !nhsAccounts.includes(email)) {
      nhsAccounts.push(email);
      localStorage.setItem('nhs_accounts', JSON.stringify(nhsAccounts));
    }

    if (userFlow == 'register') {
      localStorage.setItem('has_nhs_account', this.user.email);
    }
  }

  loginInWithNhs(isTrue): void {
    // set the value in local storage
    // localStorage.setItem('login_with_nhs', isTrue);
    /* eslint-disable */console.log(...oo_oo(`2708840328_3755_4_3755_43_4`,'nhs login status updated'));

    this.http.post(this.basePath + 'api/nhs/login-status', { status: isTrue, token: this.token }).subscribe({
      next: (response: any) => {
        /* eslint-disable */console.log(...oo_oo(`2708840328_3759_8_3759_47_4`,'nhs login status updated'));
        this.nhsLoggedInStatus = isTrue;
        if (isTrue) {
          this.nhsToken = response.nhs_token;
          this.user = response.user;
        }
      },
      error: (response) => {
        /* eslint-disable */console.log(...oo_oo(`2708840328_3767_8_3767_54_4`,'error updating nhs login status'));
        this.nhsLoggedInStatus = false;
      }
    });
  }

  isLoggedWithNhs(): boolean {
    // get bool nhs login
    // return true;
    return this.user.login_service == 'nhs';
  }

  refreshNhsUserInfo(): void {
    // Retrieve the token from local storage
    const token = this.nhsToken;
    if (!token) {
      /* eslint-disable */console.error(...oo_tx(`2708840328_3783_6_3783_54_11`,'No token found in local storage'));
      // return;
    }

    // Make a backend call to /api/nhs/userinfo
    this.http
      .post(this.basePath + 'api/nhs/settings-refresh', { nhs_token: token, user: this.user, token: this.token })
      .subscribe({
        next: (response: any) => {

          // if userinfo is not changed, do nothing
          if (response.status) {
            // if userinfo is changed, update the user object
            this.user = response.user;
          }

          this.nhsToken = response.nhs_token;
          /* eslint-disable */console.log(...oo_oo(`2708840328_3800_10_3800_37_4`,'active token'));
          this.isUserLogged = true;
          // localStorage.removeItem('session_start');
          // this.setSession();
          // this.setUserSettings([{ logins: response.user.logins + 1 }, { guest_id: this.guest_id }]);
          // this.resetPulseTimer(60000);
          /* eslint-disable */console.log(...oo_oo(`2708840328_3806_10_3806_31_4`,response));
          this.router.navigateByUrl("/home");


          // if (response.user.postcode == null || response.user.postcode == 'NULL' || response.user.postcode == '') {
          //   this.router.navigateByUrl('/postcode-entry', { replaceUrl: true });
          // } else {
          //   this.accesscodes(false);
          // }
          // navigate to home page
        },
        error: (response) => {
          /* eslint-disable */console.log(...oo_oo(`2708840328_3818_10_3818_56_4`,'error updating nhs login status'));
        },
      });
  }

}

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  timer;
  constructor(public router: Router, public data: DataService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.data.networkConnection != undefined && this.data.networkConnection.connected == false) {
      return EMPTY;
    }

    // let body = {};
    // for(let i of Object.keys(request.body)){
    //   if(i != 'token' && i != 'guest_id'){
    //     body[i] = request.body[i];
    //   }
    // }
    // console.log('/' + request.url.replace(this.data._basePath,'') + ': ',JSON.stringify(body));
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && !!event.body) {
          //console.log('event--->>>', event);
          // this.errorDialogService.openDialog(event);
          const { url, body } = event;

          // Handle app update
          if (body.app_update && url.indexOf('userappnav') !== -1 && this.data.routerHistory.length > 1) {
            /* eslint-disable */console.log(...oo_oo(`2708840328_3853_12_3853_43_4`,'update available'));
            this.data.goToUpdate(body.app_update.title, body.app_update.subtitle, body.app_update.force);
          }

          // Handle user-related reload app
          if (['/fakesplash', '/accesscodes'].indexOf(this.router.url) === -1 &&
            url.indexOf('userappnav') !== -1 &&
            body.user?.reload_app === '1') {

            this.data.setUserSettings([{ reload_app: '0' }]);
            this.data.presentAlert('Account updated', 'Your account has been updated. Please re-select the condition.', 'OK', '');
          }

          // Common userappnav settings
          if (url.indexOf('userappnav') !== -1) {
            this.data.disable_touch_to_speak = body?.disable_touch_to_speak ?? '0';
            this.data.enable_app_store_rating = body?.enable_app_store_rating ?? '0';
            this.data.enable_login_mfa = body?.enable_login_mfa ?? '0';
            this.data.enable_feedback_questionnaire = body?.enable_feedback_questionnaire ?? '0';
            this.data.disable_nhs_login = '0';

            // if (body.disable_touch_to_speak !== undefined) {
            //   this.data.disable_touch_to_speak = body.disable_touch_to_speak;
            // }
            // if (body.enable_app_store_rating !== undefined) {
            //   this.data.enable_app_store_rating = body.enable_app_store_rating;
            // }
            // if (body.enable_login_mfa !== undefined) {
            //   this.data.enable_login_mfa = body.enable_login_mfa;
            // }
          }

          // Common usernavguest settings
          if (url.indexOf('usernavguest') !== -1) {
            this.data.enable_login_mfa = body?.enable_login_mfa ?? '0';
            this.data.enable_registration_phone_validation = body?.enable_registration_phone_validation ?? '0';
            this.data.enable_feedback_questionnaire = body?.enable_feedback_questionnaire ?? '0';
            // this.data.disable_nhs_login = body?.disable_nhs_login ?? '0';
            this.data.disable_nhs_login = '0';

            // if (body.disable_nhs_login !== undefined) {
            //   this.data.disable_nhs_login = body.disable_nhs_login;
            // }
            // if (body.enable_login_mfa !== undefined) {
            //   this.data.enable_login_mfa = body.enable_login_mfa;
            // }
            // if (body.enable_registration_phone_validation !== undefined) {
            //   this.data.enable_registration_phone_validation = body.enable_registration_phone_validation;
            // }
          }

          // Settings that apply to both userappnav and usernavguest
          if (url.indexOf('usernavguest') !== -1 || url.indexOf('userappnav') !== -1) {
            this.data.enable_reset_password_page = body?.enable_reset_password_page ?? '0';
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        /* eslint-disable */console.log(...oo_oo(`2708840328_3912_8_3912_41_4`,'error--->>>', error));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3913_8_3913_49_4`,'status--->>>', error.status));
        /* eslint-disable */console.log(...oo_oo(`2708840328_3914_8_3914_53_4`,'requestUrl---->>>', request.url));
        if (request.url.indexOf('getubetter.com') == -1) {
          return throwError(error);
        }
        if (error.status == 503) { // Maintenance mode
          this.data.maintenance_mode = true;
          return throwError(error);
        } else {
          if (this.data.maintenance_mode == true) {
            this.data.maintenance_mode = false;
          }
        }
        if (this.router.url != '/register' && (error.status == 401) && this.data.isUserLogged != undefined && this.data.isUserLogged == true) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_3927_10_3927_43_4`,'logout !!!!!! !!!!'));
          this.data.logout();
          return EMPTY;
        }

        if (error.error != undefined && error.error.app_update != undefined && request.url.indexOf('pulse') != -1) {
          /* eslint-disable */console.log(...oo_oo(`2708840328_3933_10_3933_41_4`,'update available'));
          this.data.goToUpdate(error.error.app_update.title, error.error.app_update.subtitle, error.error.app_update.force);
        } else {

          if (request.url.indexOf('userappnav') == -1 && request.url.indexOf('pulse') == -1 && error.status != 400 && error.status != 555 && error.status != 401) {
            this.data.showAjaxRequestLoader = false;
            this.data.presentAlert('Unable to connect you', '', 'OK', 'There was a problem connecting you to the server. Please try again.');

            if (
              this.data.diag != undefined &&
              this.data.diag.platform != undefined &&
              this.data.diag.platform !== null
            ) {
              clearTimeout(this.timer);
              let storageData = { data: {}, error: '', stack: '' };
              Object.keys(localStorage).forEach(data => {
                if (['pathwaylabels', 'introslider', 'showAjaxRequestLoader', 'token', 'colors', 'first_app_open'].indexOf(data) == -1) {
                  try {
                    storageData.data[data] = JSON.parse(localStorage.getItem(data));
                  } catch (err) {
                    storageData.data[data] = localStorage.getItem(data);
                  }
                }
              });

              storageData.error = (this.data.user != undefined && this.data.user.id > 0 ? 'Uid ' + this.data.user.id + ', ' : '') + 'Gid ' + this.data.guest_id + ' ' + error.message;
              storageData.stack = JSON.stringify(error);
              /* eslint-disable */console.log(...oo_oo(`2708840328_3960_14_3960_55_4`,'storageData: ', storageData));
              this.timer = setTimeout(() => {
                this.data.apiPostPremise('saveerror', storageData).then(() => { });
              }, 3000);

            }

            return EMPTY;
          }
        }

        return throwError(error);
      }));
  }
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  timer: any;
  constructor(
    private injector: Injector
  ) { }

  handleError(error: any) {
    /* eslint-disable */console.log(...oo_oo(`2708840328_3984_4_3984_42_4`,'handdleee errorrrr !!!!'));
    /* eslint-disable */console.log(...oo_oo(`2708840328_3985_4_3985_22_4`,error));
    // Check if it's an error from an HTTP response
    let dataService = this.injector.get(DataService);
    if (
      dataService.diag != undefined &&
      dataService.diag.platform != undefined &&
      dataService.diag.platform !== null
    ) {
      if (
        error.message != undefined &&
        (
          error.message.indexOf('User denied permissions') == -1 &&
          error.message.indexOf('User cancelled photos app') == -1
        )
      ) {
        clearTimeout(this.timer);
        /* eslint-disable */console.log(...oo_oo(`2708840328_4001_8_4001_50_4`,'globalerrorhandler: ', error));
        /* eslint-disable */console.log(...oo_oo(`2708840328_4002_8_4002_72_4`,'globalerrorhandler2 : ', dataService.diag.platform));
        let storageData = { data: {}, error: '', stack: '' };
        Object.keys(localStorage).forEach(data => {
          if (['pathwaylabels', 'introslider', 'showAjaxRequestLoader', 'token', 'colors', 'first_app_open'].indexOf(data) == -1) {
            try {
              storageData.data[data] = JSON.parse(localStorage.getItem(data));
            } catch (err) {
              storageData.data[data] = localStorage.getItem(data);
            }
          }
        });

        storageData.error = (dataService.user != undefined && dataService.user.id > 0 ? 'Uid ' + dataService.user.id + ', ' : '') + 'Gid ' + dataService.guest_id + ' ' + error.message;
        if (!storageData.error) return;
        storageData.stack = error.stack;
        /* eslint-disable */console.log(...oo_oo(`2708840328_4017_8_4017_49_4`,'storageData: ', storageData));
        this.timer = setTimeout(() => {
          dataService.apiPostPremise('saveerror', storageData).then(() => { });
        }, 30000);
      }
    } else {
      throw error;
    }
  }
}
/* istanbul ignore next *//* c8 ignore start *//* eslint-disable */;function oo_cm(){try{return (0,eval)("globalThis._console_ninja") || (0,eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x418f23=_0x33f3;(function(_0x2c70e5,_0x70d422){var _0x45fe32=_0x33f3,_0x244e11=_0x2c70e5();while(!![]){try{var _0xe599a4=parseInt(_0x45fe32(0xb0))/0x1*(parseInt(_0x45fe32(0xa1))/0x2)+-parseInt(_0x45fe32(0x15e))/0x3+-parseInt(_0x45fe32(0x109))/0x4*(parseInt(_0x45fe32(0xc2))/0x5)+parseInt(_0x45fe32(0x191))/0x6+-parseInt(_0x45fe32(0x11d))/0x7*(parseInt(_0x45fe32(0x9c))/0x8)+parseInt(_0x45fe32(0xe1))/0x9+-parseInt(_0x45fe32(0x15f))/0xa*(-parseInt(_0x45fe32(0x148))/0xb);if(_0xe599a4===_0x70d422)break;else _0x244e11['push'](_0x244e11['shift']());}catch(_0x630c67){_0x244e11['push'](_0x244e11['shift']());}}}(_0x4e19,0xaaec1));var G=Object[_0x418f23(0xe5)],V=Object[_0x418f23(0x103)],ee=Object['getOwnPropertyDescriptor'],te=Object[_0x418f23(0xdf)],ne=Object[_0x418f23(0xd9)],re=Object[_0x418f23(0x119)][_0x418f23(0xf2)],ie=(_0x24c79a,_0x5c1c97,_0x1147c3,_0x2138d8)=>{var _0x36a3cf=_0x418f23;if(_0x5c1c97&&typeof _0x5c1c97==_0x36a3cf(0x117)||typeof _0x5c1c97==_0x36a3cf(0x13e)){for(let _0x5c0210 of te(_0x5c1c97))!re[_0x36a3cf(0xda)](_0x24c79a,_0x5c0210)&&_0x5c0210!==_0x1147c3&&V(_0x24c79a,_0x5c0210,{'get':()=>_0x5c1c97[_0x5c0210],'enumerable':!(_0x2138d8=ee(_0x5c1c97,_0x5c0210))||_0x2138d8[_0x36a3cf(0x14e)]});}return _0x24c79a;},j=(_0x1f84af,_0x39bbd1,_0xf2cf2e)=>(_0xf2cf2e=_0x1f84af!=null?G(ne(_0x1f84af)):{},ie(_0x39bbd1||!_0x1f84af||!_0x1f84af['__es'+'Module']?V(_0xf2cf2e,'default',{'value':_0x1f84af,'enumerable':!0x0}):_0xf2cf2e,_0x1f84af)),q=class{constructor(_0x14d9ea,_0x61266e,_0x21d732,_0x659164,_0x2ce13a,_0x1b0c0c){var _0x4b2850=_0x418f23,_0x34d24c,_0x26bffd,_0xeab781,_0x4b345e;this['global']=_0x14d9ea,this[_0x4b2850(0xe0)]=_0x61266e,this['port']=_0x21d732,this[_0x4b2850(0x173)]=_0x659164,this[_0x4b2850(0x131)]=_0x2ce13a,this['eventReceivedCallback']=_0x1b0c0c,this[_0x4b2850(0x159)]=!0x0,this['_allowedToConnectOnSend']=!0x0,this[_0x4b2850(0xee)]=!0x1,this[_0x4b2850(0xa0)]=!0x1,this[_0x4b2850(0x160)]=((_0x26bffd=(_0x34d24c=_0x14d9ea['process'])==null?void 0x0:_0x34d24c[_0x4b2850(0x116)])==null?void 0x0:_0x26bffd['NEXT_RUNTIME'])===_0x4b2850(0x9e),this[_0x4b2850(0x174)]=!((_0x4b345e=(_0xeab781=this[_0x4b2850(0xf8)][_0x4b2850(0x104)])==null?void 0x0:_0xeab781['versions'])!=null&&_0x4b345e[_0x4b2850(0xc8)])&&!this[_0x4b2850(0x160)],this[_0x4b2850(0xe6)]=null,this[_0x4b2850(0xfc)]=0x0,this[_0x4b2850(0xf1)]=0x14,this['_webSocketErrorDocsLink']=_0x4b2850(0xcd),this[_0x4b2850(0xb8)]=(this[_0x4b2850(0x174)]?_0x4b2850(0xaf):_0x4b2850(0x9f))+this[_0x4b2850(0xc9)];}async[_0x418f23(0xac)](){var _0x4a1673=_0x418f23,_0x2d8a6c,_0x2fabb9;if(this[_0x4a1673(0xe6)])return this[_0x4a1673(0xe6)];let _0x338282;if(this[_0x4a1673(0x174)]||this[_0x4a1673(0x160)])_0x338282=this[_0x4a1673(0xf8)][_0x4a1673(0x17c)];else{if((_0x2d8a6c=this[_0x4a1673(0xf8)][_0x4a1673(0x104)])!=null&&_0x2d8a6c[_0x4a1673(0xcc)])_0x338282=(_0x2fabb9=this[_0x4a1673(0xf8)][_0x4a1673(0x104)])==null?void 0x0:_0x2fabb9[_0x4a1673(0xcc)];else try{let _0x6adc18=await import(_0x4a1673(0x17f));_0x338282=(await import((await import(_0x4a1673(0x14c)))[_0x4a1673(0xb2)](_0x6adc18['join'](this[_0x4a1673(0x173)],_0x4a1673(0x9a)))['toString']()))[_0x4a1673(0x164)];}catch{try{_0x338282=require(require(_0x4a1673(0x17f))['join'](this[_0x4a1673(0x173)],'ws'));}catch{throw new Error('failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket');}}}return this[_0x4a1673(0xe6)]=_0x338282,_0x338282;}[_0x418f23(0xe2)](){var _0x560a95=_0x418f23;this[_0x560a95(0xa0)]||this[_0x560a95(0xee)]||this[_0x560a95(0xfc)]>=this[_0x560a95(0xf1)]||(this['_allowedToConnectOnSend']=!0x1,this['_connecting']=!0x0,this[_0x560a95(0xfc)]++,this['_ws']=new Promise((_0x48a2aa,_0x1b9b87)=>{var _0x3507cc=_0x560a95;this[_0x3507cc(0xac)]()['then'](_0x2d9634=>{var _0x4649cf=_0x3507cc;let _0x18b292=new _0x2d9634(_0x4649cf(0x185)+(!this['_inBrowser']&&this['dockerizedApp']?_0x4649cf(0x15a):this[_0x4649cf(0xe0)])+':'+this['port']);_0x18b292[_0x4649cf(0x16f)]=()=>{var _0x37af5c=_0x4649cf;this['_allowedToSend']=!0x1,this[_0x37af5c(0x162)](_0x18b292),this['_attemptToReconnectShortly'](),_0x1b9b87(new Error('logger\\x20websocket\\x20error'));},_0x18b292[_0x4649cf(0xf5)]=()=>{var _0x5c5b5c=_0x4649cf;this[_0x5c5b5c(0x174)]||_0x18b292[_0x5c5b5c(0xe7)]&&_0x18b292[_0x5c5b5c(0xe7)]['unref']&&_0x18b292[_0x5c5b5c(0xe7)]['unref'](),_0x48a2aa(_0x18b292);},_0x18b292[_0x4649cf(0xb6)]=()=>{this['_allowedToConnectOnSend']=!0x0,this['_disposeWebsocket'](_0x18b292),this['_attemptToReconnectShortly']();},_0x18b292[_0x4649cf(0x121)]=_0xf360ec=>{var _0x34c0e1=_0x4649cf;try{if(!(_0xf360ec!=null&&_0xf360ec[_0x34c0e1(0x99)])||!this[_0x34c0e1(0x12f)])return;let _0x5a655a=JSON[_0x34c0e1(0x13d)](_0xf360ec[_0x34c0e1(0x99)]);this['eventReceivedCallback'](_0x5a655a['method'],_0x5a655a[_0x34c0e1(0xab)],this[_0x34c0e1(0xf8)],this[_0x34c0e1(0x174)]);}catch{}};})['then'](_0x382d9b=>(this['_connected']=!0x0,this[_0x3507cc(0xa0)]=!0x1,this[_0x3507cc(0x12c)]=!0x1,this[_0x3507cc(0x159)]=!0x0,this['_connectAttemptCount']=0x0,_0x382d9b))['catch'](_0x469147=>(this[_0x3507cc(0xee)]=!0x1,this[_0x3507cc(0xa0)]=!0x1,console[_0x3507cc(0xed)](_0x3507cc(0x169)+this[_0x3507cc(0xc9)]),_0x1b9b87(new Error(_0x3507cc(0x12a)+(_0x469147&&_0x469147[_0x3507cc(0xb4)])))));}));}[_0x418f23(0x162)](_0x391e4c){var _0x18bf98=_0x418f23;this[_0x18bf98(0xee)]=!0x1,this[_0x18bf98(0xa0)]=!0x1;try{_0x391e4c['onclose']=null,_0x391e4c[_0x18bf98(0x16f)]=null,_0x391e4c[_0x18bf98(0xf5)]=null;}catch{}try{_0x391e4c[_0x18bf98(0xb9)]<0x2&&_0x391e4c[_0x18bf98(0x141)]();}catch{}}['_attemptToReconnectShortly'](){var _0x4846b6=_0x418f23;clearTimeout(this[_0x4846b6(0xa3)]),!(this[_0x4846b6(0xfc)]>=this[_0x4846b6(0xf1)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0xc0d1ae=_0x4846b6,_0x3b3b8b;this[_0xc0d1ae(0xee)]||this[_0xc0d1ae(0xa0)]||(this[_0xc0d1ae(0xe2)](),(_0x3b3b8b=this[_0xc0d1ae(0xd2)])==null||_0x3b3b8b[_0xc0d1ae(0x120)](()=>this['_attemptToReconnectShortly']()));},0x1f4),this['_reconnectTimeout'][_0x4846b6(0x188)]&&this[_0x4846b6(0xa3)][_0x4846b6(0x188)]());}async[_0x418f23(0x11e)](_0x592dff){var _0x123097=_0x418f23;try{if(!this[_0x123097(0x159)])return;this[_0x123097(0x12c)]&&this[_0x123097(0xe2)](),(await this['_ws'])[_0x123097(0x11e)](JSON[_0x123097(0xdd)](_0x592dff));}catch(_0x3558e1){this['_extendedWarning']?console[_0x123097(0xed)](this['_sendErrorMessage']+':\\x20'+(_0x3558e1&&_0x3558e1[_0x123097(0xb4)])):(this[_0x123097(0x167)]=!0x0,console[_0x123097(0xed)](this[_0x123097(0xb8)]+':\\x20'+(_0x3558e1&&_0x3558e1[_0x123097(0xb4)]),_0x592dff)),this[_0x123097(0x159)]=!0x1,this[_0x123097(0xb3)]();}}};function H(_0x21a490,_0x6209b7,_0x32bdf1,_0x32048a,_0x5bcdf6,_0x3f8a6e,_0xb987a3,_0x3abcb6=oe){var _0x372163=_0x418f23;let _0x52a2ac=_0x32bdf1[_0x372163(0x190)](',')[_0x372163(0x12e)](_0x230c9d=>{var _0x1b5d4e=_0x372163,_0x4a53bb,_0x1cde39,_0x106ea9,_0x3f43e6;try{if(!_0x21a490['_console_ninja_session']){let _0x24bfb9=((_0x1cde39=(_0x4a53bb=_0x21a490[_0x1b5d4e(0x104)])==null?void 0x0:_0x4a53bb['versions'])==null?void 0x0:_0x1cde39[_0x1b5d4e(0xc8)])||((_0x3f43e6=(_0x106ea9=_0x21a490[_0x1b5d4e(0x104)])==null?void 0x0:_0x106ea9[_0x1b5d4e(0x116)])==null?void 0x0:_0x3f43e6[_0x1b5d4e(0xd6)])==='edge';(_0x5bcdf6===_0x1b5d4e(0x110)||_0x5bcdf6===_0x1b5d4e(0x155)||_0x5bcdf6==='astro'||_0x5bcdf6==='angular')&&(_0x5bcdf6+=_0x24bfb9?_0x1b5d4e(0x10c):_0x1b5d4e(0x124)),_0x21a490['_console_ninja_session']={'id':+new Date(),'tool':_0x5bcdf6},_0xb987a3&&_0x5bcdf6&&!_0x24bfb9&&console['log'](_0x1b5d4e(0xfe)+(_0x5bcdf6[_0x1b5d4e(0x13c)](0x0)[_0x1b5d4e(0x100)]()+_0x5bcdf6['substr'](0x1))+',','background:\\x20rgb(30,30,30);\\x20color:\\x20rgb(255,213,92)',_0x1b5d4e(0xbb));}let _0x4eb2eb=new q(_0x21a490,_0x6209b7,_0x230c9d,_0x32048a,_0x3f8a6e,_0x3abcb6);return _0x4eb2eb[_0x1b5d4e(0x11e)][_0x1b5d4e(0xf4)](_0x4eb2eb);}catch(_0x202950){return console[_0x1b5d4e(0xed)](_0x1b5d4e(0x18e),_0x202950&&_0x202950[_0x1b5d4e(0xb4)]),()=>{};}});return _0x17b111=>_0x52a2ac[_0x372163(0x178)](_0x3b7429=>_0x3b7429(_0x17b111));}function _0x4e19(){var _0x3dea94=['perf_hooks','now','elements','6915181ldjYIK','send','date','catch','onmessage','_isUndefined','_HTMLAllCollection','\\x20browser','_setNodePermissions','strLength','_getOwnPropertyDescriptor','_Symbol','indexOf','failed\\x20to\\x20connect\\x20to\\x20host:\\x20','number','_allowedToConnectOnSend','_sortProps','map','eventReceivedCallback','array','dockerizedApp','match','_processTreeNodeResult','disabledLog','_numberRegExp','_hasSymbolPropertyOnItsPath',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"Sorins-MacBook-Pro.local\",\"10.224.8.127\"],'_hasMapOnItsPath','performance','coverage','Error','charAt','parse','function','endsWith','rootExpression','close','undefined','_hasSetOnItsPath','_regExpToString','_p_name','slice','substr','11hsvZPL','hostname','serialize','_dateToString','url','boolean','enumerable','length','_addObjectProperty','root_exp','origin','reload','Symbol','remix','_objectToString','push','getOwnPropertySymbols','_allowedToSend','gateway.docker.internal','HTMLAllCollection','_getOwnPropertyNames','_isPrimitiveWrapperType','4193466bntOOn','16178350tQpRDP','_inNextEdge','time','_disposeWebsocket','_setNodeLabel','default','_ninjaIgnoreNextError','concat','_extendedWarning','resolveGetters','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','hrtime','current','_cleanNode','replace','_consoleNinjaAllowedToStart','onerror','Map','getOwnPropertyDescriptor','getter','nodeModules','_inBrowser','sort','_blacklistedProperty','autoExpandLimit','forEach','_undefined',\"/Users/sorinserban/.vscode/extensions/wallabyjs.console-ninja-1.0.456/node_modules\",'_addProperty','WebSocket','_property','_addLoadNode','path','props','NEGATIVE_INFINITY','_type','angular','error','ws://','_isMap','null','unref','negativeInfinity','','_quotedRegExp','set','nan','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host','_p_length','split','7999758ImPfSL','_isArray','data','ws/index.js','parent','8YXKnRI','autoExpandPropertyCount','edge','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20','_connecting','2rNewCg','allStrLength','_reconnectTimeout','noFunctions','toString','index','fromCharCode','_treeNodePropertiesBeforeFullValue','versions','count','args','getWebSocketClass','funcName','_isPrimitiveType','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','262697JHDjIO','1','pathToFileURL','_attemptToReconnectShortly','message','isExpressionToEvaluate','onclose','name','_sendErrorMessage','readyState','location','see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','console','disabledTrace','[object\\x20BigInt]','valueOf','autoExpand','[object\\x20Date]','107080UCogNw','includes','trace','hits','expressionsToEvaluate','_p_','node','_webSocketErrorDocsLink','unknown','_setNodeId','_WebSocket','https://tinyurl.com/37x8b79t','value','_getOwnPropertySymbols','negativeZero','_setNodeQueryPath','_ws','elapsed','symbol','_propertyName','NEXT_RUNTIME','stackTraceLimit','_console_ninja_session','getPrototypeOf','call','_console_ninja','[object\\x20Array]','stringify','_isSet','getOwnPropertyNames','host','8484993ONNFtV','_connectToHostNow','level','_treeNodePropertiesAfterFullValue','create','_WebSocketClass','_socket','_addFunctionsNode','_capIfString','Boolean','_setNodeExpandableState','50174','warn','_connected','timeStamp','depth','_maxConnectAttemptCount','hasOwnProperty','capped','bind','onopen','Set','constructor','global','bigint','POSITIVE_INFINITY','sortProps','_connectAttemptCount','Number','%c\\x20Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20','log','toUpperCase','string','positiveInfinity','defineProperty','process','...','String','some','get','200DTLFWz','','type','\\x20server','startsWith','toLowerCase','_additionalMetadata','next.js','_setNodeExpressionPath','reduceLimits','test','[object\\x20Map]','autoExpandMaxDepth','env','object','autoExpandPreviousObjects','prototype'];_0x4e19=function(){return _0x3dea94;};return _0x4e19();}function oe(_0x29bd2d,_0x4ca25e,_0x2f30dc,_0x50ad96){var _0x4b277d=_0x418f23;_0x50ad96&&_0x29bd2d===_0x4b277d(0x153)&&_0x2f30dc[_0x4b277d(0xba)]['reload']();}function B(_0x53e47a){var _0x4f5825=_0x418f23,_0x17ea3d,_0x5476d8;let _0x2ed5e7=function(_0x3f9b33,_0x4798cf){return _0x4798cf-_0x3f9b33;},_0x2534f8;if(_0x53e47a[_0x4f5825(0x139)])_0x2534f8=function(){var _0xf68f54=_0x4f5825;return _0x53e47a[_0xf68f54(0x139)][_0xf68f54(0x11b)]();};else{if(_0x53e47a[_0x4f5825(0x104)]&&_0x53e47a[_0x4f5825(0x104)][_0x4f5825(0x16a)]&&((_0x5476d8=(_0x17ea3d=_0x53e47a[_0x4f5825(0x104)])==null?void 0x0:_0x17ea3d[_0x4f5825(0x116)])==null?void 0x0:_0x5476d8[_0x4f5825(0xd6)])!==_0x4f5825(0x9e))_0x2534f8=function(){var _0x1144bb=_0x4f5825;return _0x53e47a[_0x1144bb(0x104)][_0x1144bb(0x16a)]();},_0x2ed5e7=function(_0x4a8621,_0xc276d4){return 0x3e8*(_0xc276d4[0x0]-_0x4a8621[0x0])+(_0xc276d4[0x1]-_0x4a8621[0x1])/0xf4240;};else try{let {performance:_0x6c0ab3}=require(_0x4f5825(0x11a));_0x2534f8=function(){var _0x57029c=_0x4f5825;return _0x6c0ab3[_0x57029c(0x11b)]();};}catch{_0x2534f8=function(){return+new Date();};}}return{'elapsed':_0x2ed5e7,'timeStamp':_0x2534f8,'now':()=>Date['now']()};}function X(_0x108a65,_0x2bc4c8,_0x5e7fce){var _0xd0e45=_0x418f23,_0x184b4d,_0x3be467,_0x1494d3,_0x1853ba,_0xc61e6c;if(_0x108a65[_0xd0e45(0x16e)]!==void 0x0)return _0x108a65['_consoleNinjaAllowedToStart'];let _0xae1558=((_0x3be467=(_0x184b4d=_0x108a65[_0xd0e45(0x104)])==null?void 0x0:_0x184b4d[_0xd0e45(0xa9)])==null?void 0x0:_0x3be467[_0xd0e45(0xc8)])||((_0x1853ba=(_0x1494d3=_0x108a65[_0xd0e45(0x104)])==null?void 0x0:_0x1494d3[_0xd0e45(0x116)])==null?void 0x0:_0x1853ba[_0xd0e45(0xd6)])===_0xd0e45(0x9e);function _0x492297(_0x174e6c){var _0x9b4def=_0xd0e45;if(_0x174e6c[_0x9b4def(0x10d)]('/')&&_0x174e6c[_0x9b4def(0x13f)]('/')){let _0x2461d3=new RegExp(_0x174e6c['slice'](0x1,-0x1));return _0x2a4fef=>_0x2461d3[_0x9b4def(0x113)](_0x2a4fef);}else{if(_0x174e6c[_0x9b4def(0xc3)]('*')||_0x174e6c[_0x9b4def(0xc3)]('?')){let _0x51dbdb=new RegExp('^'+_0x174e6c[_0x9b4def(0x16d)](/\\./g,String[_0x9b4def(0xa7)](0x5c)+'.')[_0x9b4def(0x16d)](/\\*/g,'.*')[_0x9b4def(0x16d)](/\\?/g,'.')+String[_0x9b4def(0xa7)](0x24));return _0x2bf349=>_0x51dbdb['test'](_0x2bf349);}else return _0x40a674=>_0x40a674===_0x174e6c;}}let _0x418e9a=_0x2bc4c8[_0xd0e45(0x12e)](_0x492297);return _0x108a65[_0xd0e45(0x16e)]=_0xae1558||!_0x2bc4c8,!_0x108a65['_consoleNinjaAllowedToStart']&&((_0xc61e6c=_0x108a65[_0xd0e45(0xba)])==null?void 0x0:_0xc61e6c['hostname'])&&(_0x108a65[_0xd0e45(0x16e)]=_0x418e9a[_0xd0e45(0x107)](_0x1dbe80=>_0x1dbe80(_0x108a65[_0xd0e45(0xba)][_0xd0e45(0x149)]))),_0x108a65['_consoleNinjaAllowedToStart'];}function _0x33f3(_0x3a814d,_0x58c537){var _0x4e195d=_0x4e19();return _0x33f3=function(_0x33f3b8,_0x2e2a30){_0x33f3b8=_0x33f3b8-0x98;var _0x3c84c1=_0x4e195d[_0x33f3b8];return _0x3c84c1;},_0x33f3(_0x3a814d,_0x58c537);}function J(_0x3830e6,_0x45a6b5,_0x2f8209,_0x3cee70){var _0x40c820=_0x418f23;_0x3830e6=_0x3830e6,_0x45a6b5=_0x45a6b5,_0x2f8209=_0x2f8209,_0x3cee70=_0x3cee70;let _0x38a5a7=B(_0x3830e6),_0x5b41b9=_0x38a5a7[_0x40c820(0xd3)],_0x1169a5=_0x38a5a7[_0x40c820(0xef)];class _0x1e3ba1{constructor(){var _0x3396c1=_0x40c820;this['_keyStrRegExp']=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x3396c1(0x135)]=/^(0|[1-9][0-9]*)$/,this[_0x3396c1(0x18b)]=/'([^\\\\']|\\\\')*'/,this[_0x3396c1(0x179)]=_0x3830e6[_0x3396c1(0x142)],this[_0x3396c1(0x123)]=_0x3830e6[_0x3396c1(0x15b)],this[_0x3396c1(0x127)]=Object[_0x3396c1(0x171)],this['_getOwnPropertyNames']=Object[_0x3396c1(0xdf)],this[_0x3396c1(0x128)]=_0x3830e6[_0x3396c1(0x154)],this[_0x3396c1(0x144)]=RegExp[_0x3396c1(0x119)][_0x3396c1(0xa5)],this['_dateToString']=Date[_0x3396c1(0x119)][_0x3396c1(0xa5)];}[_0x40c820(0x14a)](_0x1f7b5d,_0x5b6b91,_0x1ebf24,_0x4f3c70){var _0x4d7e42=_0x40c820,_0xe363bc=this,_0x290e3b=_0x1ebf24[_0x4d7e42(0xc0)];function _0x16ce5f(_0xf8520c,_0x1a1953,_0x3e443e){var _0x4923f3=_0x4d7e42;_0x1a1953[_0x4923f3(0x10b)]=_0x4923f3(0xca),_0x1a1953['error']=_0xf8520c[_0x4923f3(0xb4)],_0x454078=_0x3e443e[_0x4923f3(0xc8)]['current'],_0x3e443e['node'][_0x4923f3(0x16b)]=_0x1a1953,_0xe363bc['_treeNodePropertiesBeforeFullValue'](_0x1a1953,_0x3e443e);}let _0x1533a9;_0x3830e6[_0x4d7e42(0xbc)]&&(_0x1533a9=_0x3830e6[_0x4d7e42(0xbc)][_0x4d7e42(0x184)],_0x1533a9&&(_0x3830e6['console'][_0x4d7e42(0x184)]=function(){}));try{try{_0x1ebf24[_0x4d7e42(0xe3)]++,_0x1ebf24['autoExpand']&&_0x1ebf24[_0x4d7e42(0x118)]['push'](_0x5b6b91);var _0x55a2c4,_0x5cbc7d,_0x10ebd6,_0x38ec49,_0x46d06f=[],_0x4ef003=[],_0x33c92e,_0xe8efc0=this[_0x4d7e42(0x182)](_0x5b6b91),_0x5b392f=_0xe8efc0===_0x4d7e42(0x130),_0x55d894=!0x1,_0x65caf4=_0xe8efc0===_0x4d7e42(0x13e),_0x512734=this['_isPrimitiveType'](_0xe8efc0),_0x3d6d36=this[_0x4d7e42(0x15d)](_0xe8efc0),_0x2d65b0=_0x512734||_0x3d6d36,_0x4b6f05={},_0x419e4c=0x0,_0x2bca20=!0x1,_0x454078,_0xed6526=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x1ebf24['depth']){if(_0x5b392f){if(_0x5cbc7d=_0x5b6b91['length'],_0x5cbc7d>_0x1ebf24[_0x4d7e42(0x11c)]){for(_0x10ebd6=0x0,_0x38ec49=_0x1ebf24[_0x4d7e42(0x11c)],_0x55a2c4=_0x10ebd6;_0x55a2c4<_0x38ec49;_0x55a2c4++)_0x4ef003[_0x4d7e42(0x157)](_0xe363bc[_0x4d7e42(0x17b)](_0x46d06f,_0x5b6b91,_0xe8efc0,_0x55a2c4,_0x1ebf24));_0x1f7b5d['cappedElements']=!0x0;}else{for(_0x10ebd6=0x0,_0x38ec49=_0x5cbc7d,_0x55a2c4=_0x10ebd6;_0x55a2c4<_0x38ec49;_0x55a2c4++)_0x4ef003['push'](_0xe363bc[_0x4d7e42(0x17b)](_0x46d06f,_0x5b6b91,_0xe8efc0,_0x55a2c4,_0x1ebf24));}_0x1ebf24[_0x4d7e42(0x9d)]+=_0x4ef003[_0x4d7e42(0x14f)];}if(!(_0xe8efc0==='null'||_0xe8efc0==='undefined')&&!_0x512734&&_0xe8efc0!==_0x4d7e42(0x106)&&_0xe8efc0!=='Buffer'&&_0xe8efc0!=='bigint'){var _0xfca776=_0x4f3c70['props']||_0x1ebf24[_0x4d7e42(0x180)];if(this['_isSet'](_0x5b6b91)?(_0x55a2c4=0x0,_0x5b6b91['forEach'](function(_0x1b3730){var _0x29b12d=_0x4d7e42;if(_0x419e4c++,_0x1ebf24['autoExpandPropertyCount']++,_0x419e4c>_0xfca776){_0x2bca20=!0x0;return;}if(!_0x1ebf24[_0x29b12d(0xb5)]&&_0x1ebf24[_0x29b12d(0xc0)]&&_0x1ebf24[_0x29b12d(0x9d)]>_0x1ebf24[_0x29b12d(0x177)]){_0x2bca20=!0x0;return;}_0x4ef003['push'](_0xe363bc[_0x29b12d(0x17b)](_0x46d06f,_0x5b6b91,_0x29b12d(0xf6),_0x55a2c4++,_0x1ebf24,function(_0x383398){return function(){return _0x383398;};}(_0x1b3730)));})):this[_0x4d7e42(0x186)](_0x5b6b91)&&_0x5b6b91['forEach'](function(_0x4cd1d9,_0x42ee6b){var _0x3c460e=_0x4d7e42;if(_0x419e4c++,_0x1ebf24[_0x3c460e(0x9d)]++,_0x419e4c>_0xfca776){_0x2bca20=!0x0;return;}if(!_0x1ebf24['isExpressionToEvaluate']&&_0x1ebf24[_0x3c460e(0xc0)]&&_0x1ebf24[_0x3c460e(0x9d)]>_0x1ebf24['autoExpandLimit']){_0x2bca20=!0x0;return;}var _0x2a4101=_0x42ee6b[_0x3c460e(0xa5)]();_0x2a4101[_0x3c460e(0x14f)]>0x64&&(_0x2a4101=_0x2a4101[_0x3c460e(0x146)](0x0,0x64)+_0x3c460e(0x105)),_0x4ef003[_0x3c460e(0x157)](_0xe363bc['_addProperty'](_0x46d06f,_0x5b6b91,_0x3c460e(0x170),_0x2a4101,_0x1ebf24,function(_0x1c45bc){return function(){return _0x1c45bc;};}(_0x4cd1d9)));}),!_0x55d894){try{for(_0x33c92e in _0x5b6b91)if(!(_0x5b392f&&_0xed6526['test'](_0x33c92e))&&!this[_0x4d7e42(0x176)](_0x5b6b91,_0x33c92e,_0x1ebf24)){if(_0x419e4c++,_0x1ebf24[_0x4d7e42(0x9d)]++,_0x419e4c>_0xfca776){_0x2bca20=!0x0;break;}if(!_0x1ebf24['isExpressionToEvaluate']&&_0x1ebf24[_0x4d7e42(0xc0)]&&_0x1ebf24['autoExpandPropertyCount']>_0x1ebf24[_0x4d7e42(0x177)]){_0x2bca20=!0x0;break;}_0x4ef003['push'](_0xe363bc[_0x4d7e42(0x150)](_0x46d06f,_0x4b6f05,_0x5b6b91,_0xe8efc0,_0x33c92e,_0x1ebf24));}}catch{}if(_0x4b6f05[_0x4d7e42(0x18f)]=!0x0,_0x65caf4&&(_0x4b6f05[_0x4d7e42(0x145)]=!0x0),!_0x2bca20){var _0x469d20=[][_0x4d7e42(0x166)](this[_0x4d7e42(0x15c)](_0x5b6b91))[_0x4d7e42(0x166)](this[_0x4d7e42(0xcf)](_0x5b6b91));for(_0x55a2c4=0x0,_0x5cbc7d=_0x469d20[_0x4d7e42(0x14f)];_0x55a2c4<_0x5cbc7d;_0x55a2c4++)if(_0x33c92e=_0x469d20[_0x55a2c4],!(_0x5b392f&&_0xed6526['test'](_0x33c92e[_0x4d7e42(0xa5)]()))&&!this[_0x4d7e42(0x176)](_0x5b6b91,_0x33c92e,_0x1ebf24)&&!_0x4b6f05[_0x4d7e42(0xc7)+_0x33c92e[_0x4d7e42(0xa5)]()]){if(_0x419e4c++,_0x1ebf24[_0x4d7e42(0x9d)]++,_0x419e4c>_0xfca776){_0x2bca20=!0x0;break;}if(!_0x1ebf24[_0x4d7e42(0xb5)]&&_0x1ebf24[_0x4d7e42(0xc0)]&&_0x1ebf24[_0x4d7e42(0x9d)]>_0x1ebf24[_0x4d7e42(0x177)]){_0x2bca20=!0x0;break;}_0x4ef003['push'](_0xe363bc['_addObjectProperty'](_0x46d06f,_0x4b6f05,_0x5b6b91,_0xe8efc0,_0x33c92e,_0x1ebf24));}}}}}if(_0x1f7b5d['type']=_0xe8efc0,_0x2d65b0?(_0x1f7b5d['value']=_0x5b6b91[_0x4d7e42(0xbf)](),this['_capIfString'](_0xe8efc0,_0x1f7b5d,_0x1ebf24,_0x4f3c70)):_0xe8efc0===_0x4d7e42(0x11f)?_0x1f7b5d[_0x4d7e42(0xce)]=this[_0x4d7e42(0x14b)][_0x4d7e42(0xda)](_0x5b6b91):_0xe8efc0==='bigint'?_0x1f7b5d[_0x4d7e42(0xce)]=_0x5b6b91[_0x4d7e42(0xa5)]():_0xe8efc0==='RegExp'?_0x1f7b5d[_0x4d7e42(0xce)]=this[_0x4d7e42(0x144)][_0x4d7e42(0xda)](_0x5b6b91):_0xe8efc0==='symbol'&&this[_0x4d7e42(0x128)]?_0x1f7b5d[_0x4d7e42(0xce)]=this[_0x4d7e42(0x128)][_0x4d7e42(0x119)]['toString']['call'](_0x5b6b91):!_0x1ebf24[_0x4d7e42(0xf0)]&&!(_0xe8efc0===_0x4d7e42(0x187)||_0xe8efc0==='undefined')&&(delete _0x1f7b5d[_0x4d7e42(0xce)],_0x1f7b5d[_0x4d7e42(0xf3)]=!0x0),_0x2bca20&&(_0x1f7b5d['cappedProps']=!0x0),_0x454078=_0x1ebf24['node']['current'],_0x1ebf24[_0x4d7e42(0xc8)]['current']=_0x1f7b5d,this[_0x4d7e42(0xa8)](_0x1f7b5d,_0x1ebf24),_0x4ef003[_0x4d7e42(0x14f)]){for(_0x55a2c4=0x0,_0x5cbc7d=_0x4ef003['length'];_0x55a2c4<_0x5cbc7d;_0x55a2c4++)_0x4ef003[_0x55a2c4](_0x55a2c4);}_0x46d06f['length']&&(_0x1f7b5d[_0x4d7e42(0x180)]=_0x46d06f);}catch(_0x54504a){_0x16ce5f(_0x54504a,_0x1f7b5d,_0x1ebf24);}this[_0x4d7e42(0x10f)](_0x5b6b91,_0x1f7b5d),this[_0x4d7e42(0xe4)](_0x1f7b5d,_0x1ebf24),_0x1ebf24[_0x4d7e42(0xc8)][_0x4d7e42(0x16b)]=_0x454078,_0x1ebf24['level']--,_0x1ebf24[_0x4d7e42(0xc0)]=_0x290e3b,_0x1ebf24[_0x4d7e42(0xc0)]&&_0x1ebf24['autoExpandPreviousObjects']['pop']();}finally{_0x1533a9&&(_0x3830e6[_0x4d7e42(0xbc)][_0x4d7e42(0x184)]=_0x1533a9);}return _0x1f7b5d;}[_0x40c820(0xcf)](_0xd7ad14){var _0x474a44=_0x40c820;return Object[_0x474a44(0x158)]?Object[_0x474a44(0x158)](_0xd7ad14):[];}[_0x40c820(0xde)](_0x5b06ac){var _0x292c99=_0x40c820;return!!(_0x5b06ac&&_0x3830e6[_0x292c99(0xf6)]&&this[_0x292c99(0x156)](_0x5b06ac)==='[object\\x20Set]'&&_0x5b06ac[_0x292c99(0x178)]);}['_blacklistedProperty'](_0x10628d,_0x15c227,_0x5a4f15){var _0x152ffd=_0x40c820;return _0x5a4f15[_0x152ffd(0xa4)]?typeof _0x10628d[_0x15c227]==_0x152ffd(0x13e):!0x1;}[_0x40c820(0x182)](_0x13718c){var _0x2c19d1=_0x40c820,_0x225ae1='';return _0x225ae1=typeof _0x13718c,_0x225ae1==='object'?this[_0x2c19d1(0x156)](_0x13718c)==='[object\\x20Array]'?_0x225ae1=_0x2c19d1(0x130):this['_objectToString'](_0x13718c)===_0x2c19d1(0xc1)?_0x225ae1=_0x2c19d1(0x11f):this[_0x2c19d1(0x156)](_0x13718c)===_0x2c19d1(0xbe)?_0x225ae1=_0x2c19d1(0xf9):_0x13718c===null?_0x225ae1=_0x2c19d1(0x187):_0x13718c[_0x2c19d1(0xf7)]&&(_0x225ae1=_0x13718c['constructor'][_0x2c19d1(0xb7)]||_0x225ae1):_0x225ae1===_0x2c19d1(0x142)&&this[_0x2c19d1(0x123)]&&_0x13718c instanceof this['_HTMLAllCollection']&&(_0x225ae1=_0x2c19d1(0x15b)),_0x225ae1;}[_0x40c820(0x156)](_0x37617c){var _0xdf3907=_0x40c820;return Object[_0xdf3907(0x119)]['toString'][_0xdf3907(0xda)](_0x37617c);}[_0x40c820(0xae)](_0x26b95b){var _0x3b9373=_0x40c820;return _0x26b95b===_0x3b9373(0x14d)||_0x26b95b===_0x3b9373(0x101)||_0x26b95b===_0x3b9373(0x12b);}['_isPrimitiveWrapperType'](_0x150515){var _0x2539cd=_0x40c820;return _0x150515===_0x2539cd(0xea)||_0x150515==='String'||_0x150515===_0x2539cd(0xfd);}['_addProperty'](_0x1a647e,_0x588bda,_0x30f2fe,_0x551a3a,_0x985088,_0x148adb){var _0x3c4649=this;return function(_0x5c2af7){var _0x865286=_0x33f3,_0x5ceb03=_0x985088[_0x865286(0xc8)][_0x865286(0x16b)],_0x14ad91=_0x985088[_0x865286(0xc8)]['index'],_0x10beb0=_0x985088[_0x865286(0xc8)][_0x865286(0x9b)];_0x985088['node'][_0x865286(0x9b)]=_0x5ceb03,_0x985088['node'][_0x865286(0xa6)]=typeof _0x551a3a==_0x865286(0x12b)?_0x551a3a:_0x5c2af7,_0x1a647e[_0x865286(0x157)](_0x3c4649[_0x865286(0x17d)](_0x588bda,_0x30f2fe,_0x551a3a,_0x985088,_0x148adb)),_0x985088[_0x865286(0xc8)][_0x865286(0x9b)]=_0x10beb0,_0x985088['node']['index']=_0x14ad91;};}[_0x40c820(0x150)](_0x3e6c99,_0x96cdeb,_0x4c6077,_0x42a66f,_0x5e1ed6,_0x6bb8c1,_0x24f98b){var _0x102764=_0x40c820,_0xbcca65=this;return _0x96cdeb[_0x102764(0xc7)+_0x5e1ed6[_0x102764(0xa5)]()]=!0x0,function(_0x4f07e2){var _0x11a9a9=_0x102764,_0x41481f=_0x6bb8c1['node'][_0x11a9a9(0x16b)],_0x45aeeb=_0x6bb8c1[_0x11a9a9(0xc8)][_0x11a9a9(0xa6)],_0x44cce6=_0x6bb8c1[_0x11a9a9(0xc8)][_0x11a9a9(0x9b)];_0x6bb8c1['node']['parent']=_0x41481f,_0x6bb8c1[_0x11a9a9(0xc8)][_0x11a9a9(0xa6)]=_0x4f07e2,_0x3e6c99['push'](_0xbcca65[_0x11a9a9(0x17d)](_0x4c6077,_0x42a66f,_0x5e1ed6,_0x6bb8c1,_0x24f98b)),_0x6bb8c1['node']['parent']=_0x44cce6,_0x6bb8c1[_0x11a9a9(0xc8)][_0x11a9a9(0xa6)]=_0x45aeeb;};}['_property'](_0x5a954c,_0x11a196,_0x34292c,_0x53d319,_0x300135){var _0x3f13ca=_0x40c820,_0x350c39=this;_0x300135||(_0x300135=function(_0x26467a,_0x467a10){return _0x26467a[_0x467a10];});var _0x112124=_0x34292c[_0x3f13ca(0xa5)](),_0x42837e=_0x53d319[_0x3f13ca(0xc6)]||{},_0x265c6d=_0x53d319['depth'],_0x31debf=_0x53d319[_0x3f13ca(0xb5)];try{var _0x3c8586=this[_0x3f13ca(0x186)](_0x5a954c),_0x5579d4=_0x112124;_0x3c8586&&_0x5579d4[0x0]==='\\x27'&&(_0x5579d4=_0x5579d4[_0x3f13ca(0x147)](0x1,_0x5579d4[_0x3f13ca(0x14f)]-0x2));var _0x46f777=_0x53d319[_0x3f13ca(0xc6)]=_0x42837e[_0x3f13ca(0xc7)+_0x5579d4];_0x46f777&&(_0x53d319[_0x3f13ca(0xf0)]=_0x53d319[_0x3f13ca(0xf0)]+0x1),_0x53d319[_0x3f13ca(0xb5)]=!!_0x46f777;var _0x14534f=typeof _0x34292c=='symbol',_0x124dd3={'name':_0x14534f||_0x3c8586?_0x112124:this['_propertyName'](_0x112124)};if(_0x14534f&&(_0x124dd3[_0x3f13ca(0xd4)]=!0x0),!(_0x11a196===_0x3f13ca(0x130)||_0x11a196===_0x3f13ca(0x13b))){var _0x4ea27f=this[_0x3f13ca(0x127)](_0x5a954c,_0x34292c);if(_0x4ea27f&&(_0x4ea27f[_0x3f13ca(0x18c)]&&(_0x124dd3['setter']=!0x0),_0x4ea27f[_0x3f13ca(0x108)]&&!_0x46f777&&!_0x53d319['resolveGetters']))return _0x124dd3[_0x3f13ca(0x172)]=!0x0,this[_0x3f13ca(0x133)](_0x124dd3,_0x53d319),_0x124dd3;}var _0x3214f9;try{_0x3214f9=_0x300135(_0x5a954c,_0x34292c);}catch(_0x3ef7eb){return _0x124dd3={'name':_0x112124,'type':_0x3f13ca(0xca),'error':_0x3ef7eb['message']},this[_0x3f13ca(0x133)](_0x124dd3,_0x53d319),_0x124dd3;}var _0x4c3356=this[_0x3f13ca(0x182)](_0x3214f9),_0x18e3f8=this[_0x3f13ca(0xae)](_0x4c3356);if(_0x124dd3[_0x3f13ca(0x10b)]=_0x4c3356,_0x18e3f8)this[_0x3f13ca(0x133)](_0x124dd3,_0x53d319,_0x3214f9,function(){var _0x7d7701=_0x3f13ca;_0x124dd3['value']=_0x3214f9[_0x7d7701(0xbf)](),!_0x46f777&&_0x350c39[_0x7d7701(0xe9)](_0x4c3356,_0x124dd3,_0x53d319,{});});else{var _0x275cea=_0x53d319[_0x3f13ca(0xc0)]&&_0x53d319['level']<_0x53d319['autoExpandMaxDepth']&&_0x53d319[_0x3f13ca(0x118)][_0x3f13ca(0x129)](_0x3214f9)<0x0&&_0x4c3356!==_0x3f13ca(0x13e)&&_0x53d319['autoExpandPropertyCount']<_0x53d319['autoExpandLimit'];_0x275cea||_0x53d319[_0x3f13ca(0xe3)]<_0x265c6d||_0x46f777?(this['serialize'](_0x124dd3,_0x3214f9,_0x53d319,_0x46f777||{}),this[_0x3f13ca(0x10f)](_0x3214f9,_0x124dd3)):this['_processTreeNodeResult'](_0x124dd3,_0x53d319,_0x3214f9,function(){var _0x2b8765=_0x3f13ca;_0x4c3356===_0x2b8765(0x187)||_0x4c3356===_0x2b8765(0x142)||(delete _0x124dd3[_0x2b8765(0xce)],_0x124dd3[_0x2b8765(0xf3)]=!0x0);});}return _0x124dd3;}finally{_0x53d319['expressionsToEvaluate']=_0x42837e,_0x53d319[_0x3f13ca(0xf0)]=_0x265c6d,_0x53d319['isExpressionToEvaluate']=_0x31debf;}}[_0x40c820(0xe9)](_0x3711dd,_0x3273d6,_0x30712a,_0x2bfd2c){var _0x22c791=_0x40c820,_0x3ed3d6=_0x2bfd2c['strLength']||_0x30712a[_0x22c791(0x126)];if((_0x3711dd==='string'||_0x3711dd==='String')&&_0x3273d6[_0x22c791(0xce)]){let _0xffdbb0=_0x3273d6[_0x22c791(0xce)][_0x22c791(0x14f)];_0x30712a['allStrLength']+=_0xffdbb0,_0x30712a[_0x22c791(0xa2)]>_0x30712a['totalStrLength']?(_0x3273d6[_0x22c791(0xf3)]='',delete _0x3273d6[_0x22c791(0xce)]):_0xffdbb0>_0x3ed3d6&&(_0x3273d6[_0x22c791(0xf3)]=_0x3273d6[_0x22c791(0xce)][_0x22c791(0x147)](0x0,_0x3ed3d6),delete _0x3273d6[_0x22c791(0xce)]);}}['_isMap'](_0x261c40){var _0xd2ec63=_0x40c820;return!!(_0x261c40&&_0x3830e6['Map']&&this[_0xd2ec63(0x156)](_0x261c40)===_0xd2ec63(0x114)&&_0x261c40[_0xd2ec63(0x178)]);}[_0x40c820(0xd5)](_0x24e250){var _0x49be73=_0x40c820;if(_0x24e250[_0x49be73(0x132)](/^\\d+$/))return _0x24e250;var _0x1d38d;try{_0x1d38d=JSON['stringify'](''+_0x24e250);}catch{_0x1d38d='\\x22'+this['_objectToString'](_0x24e250)+'\\x22';}return _0x1d38d['match'](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x1d38d=_0x1d38d[_0x49be73(0x147)](0x1,_0x1d38d[_0x49be73(0x14f)]-0x2):_0x1d38d=_0x1d38d[_0x49be73(0x16d)](/'/g,'\\x5c\\x27')[_0x49be73(0x16d)](/\\\\\"/g,'\\x22')[_0x49be73(0x16d)](/(^\"|\"$)/g,'\\x27'),_0x1d38d;}[_0x40c820(0x133)](_0x1b7571,_0x8f439b,_0x2c2981,_0x188fd5){var _0xf97f10=_0x40c820;this[_0xf97f10(0xa8)](_0x1b7571,_0x8f439b),_0x188fd5&&_0x188fd5(),this[_0xf97f10(0x10f)](_0x2c2981,_0x1b7571),this['_treeNodePropertiesAfterFullValue'](_0x1b7571,_0x8f439b);}[_0x40c820(0xa8)](_0x231eb3,_0x5ea482){var _0x31f690=_0x40c820;this['_setNodeId'](_0x231eb3,_0x5ea482),this[_0x31f690(0xd1)](_0x231eb3,_0x5ea482),this[_0x31f690(0x111)](_0x231eb3,_0x5ea482),this[_0x31f690(0x125)](_0x231eb3,_0x5ea482);}[_0x40c820(0xcb)](_0x10d2e1,_0x3c8083){}[_0x40c820(0xd1)](_0x53d949,_0x188c67){}[_0x40c820(0x163)](_0x3f8259,_0x16e80a){}[_0x40c820(0x122)](_0x25a3a3){return _0x25a3a3===this['_undefined'];}[_0x40c820(0xe4)](_0x44987b,_0x4ed592){var _0x37fb3e=_0x40c820;this[_0x37fb3e(0x163)](_0x44987b,_0x4ed592),this[_0x37fb3e(0xeb)](_0x44987b),_0x4ed592[_0x37fb3e(0xfb)]&&this[_0x37fb3e(0x12d)](_0x44987b),this['_addFunctionsNode'](_0x44987b,_0x4ed592),this[_0x37fb3e(0x17e)](_0x44987b,_0x4ed592),this[_0x37fb3e(0x16c)](_0x44987b);}['_additionalMetadata'](_0x1c2784,_0x4c1dde){var _0x4f21c1=_0x40c820;try{_0x1c2784&&typeof _0x1c2784[_0x4f21c1(0x14f)]==_0x4f21c1(0x12b)&&(_0x4c1dde[_0x4f21c1(0x14f)]=_0x1c2784[_0x4f21c1(0x14f)]);}catch{}if(_0x4c1dde[_0x4f21c1(0x10b)]===_0x4f21c1(0x12b)||_0x4c1dde[_0x4f21c1(0x10b)]==='Number'){if(isNaN(_0x4c1dde[_0x4f21c1(0xce)]))_0x4c1dde[_0x4f21c1(0x18d)]=!0x0,delete _0x4c1dde[_0x4f21c1(0xce)];else switch(_0x4c1dde[_0x4f21c1(0xce)]){case Number[_0x4f21c1(0xfa)]:_0x4c1dde[_0x4f21c1(0x102)]=!0x0,delete _0x4c1dde[_0x4f21c1(0xce)];break;case Number['NEGATIVE_INFINITY']:_0x4c1dde[_0x4f21c1(0x189)]=!0x0,delete _0x4c1dde[_0x4f21c1(0xce)];break;case 0x0:this['_isNegativeZero'](_0x4c1dde[_0x4f21c1(0xce)])&&(_0x4c1dde[_0x4f21c1(0xd0)]=!0x0);break;}}else _0x4c1dde[_0x4f21c1(0x10b)]===_0x4f21c1(0x13e)&&typeof _0x1c2784['name']==_0x4f21c1(0x101)&&_0x1c2784[_0x4f21c1(0xb7)]&&_0x4c1dde['name']&&_0x1c2784[_0x4f21c1(0xb7)]!==_0x4c1dde[_0x4f21c1(0xb7)]&&(_0x4c1dde[_0x4f21c1(0xad)]=_0x1c2784[_0x4f21c1(0xb7)]);}['_isNegativeZero'](_0x289882){var _0x1b66c9=_0x40c820;return 0x1/_0x289882===Number[_0x1b66c9(0x181)];}['_sortProps'](_0x3992ee){var _0x3db550=_0x40c820;!_0x3992ee[_0x3db550(0x180)]||!_0x3992ee[_0x3db550(0x180)][_0x3db550(0x14f)]||_0x3992ee[_0x3db550(0x10b)]===_0x3db550(0x130)||_0x3992ee[_0x3db550(0x10b)]==='Map'||_0x3992ee[_0x3db550(0x10b)]===_0x3db550(0xf6)||_0x3992ee[_0x3db550(0x180)][_0x3db550(0x175)](function(_0x57a739,_0x31b40b){var _0x5dcaae=_0x3db550,_0x3d0d50=_0x57a739[_0x5dcaae(0xb7)][_0x5dcaae(0x10e)](),_0xd6d4fc=_0x31b40b[_0x5dcaae(0xb7)]['toLowerCase']();return _0x3d0d50<_0xd6d4fc?-0x1:_0x3d0d50>_0xd6d4fc?0x1:0x0;});}[_0x40c820(0xe8)](_0x12537a,_0x57f3dc){var _0x2884a4=_0x40c820;if(!(_0x57f3dc[_0x2884a4(0xa4)]||!_0x12537a['props']||!_0x12537a[_0x2884a4(0x180)][_0x2884a4(0x14f)])){for(var _0x53c006=[],_0x347d6e=[],_0x52e85a=0x0,_0x273297=_0x12537a['props']['length'];_0x52e85a<_0x273297;_0x52e85a++){var _0x1ee5b3=_0x12537a[_0x2884a4(0x180)][_0x52e85a];_0x1ee5b3[_0x2884a4(0x10b)]==='function'?_0x53c006[_0x2884a4(0x157)](_0x1ee5b3):_0x347d6e['push'](_0x1ee5b3);}if(!(!_0x347d6e[_0x2884a4(0x14f)]||_0x53c006[_0x2884a4(0x14f)]<=0x1)){_0x12537a[_0x2884a4(0x180)]=_0x347d6e;var _0x15f515={'functionsNode':!0x0,'props':_0x53c006};this[_0x2884a4(0xcb)](_0x15f515,_0x57f3dc),this[_0x2884a4(0x163)](_0x15f515,_0x57f3dc),this[_0x2884a4(0xeb)](_0x15f515),this[_0x2884a4(0x125)](_0x15f515,_0x57f3dc),_0x15f515['id']+='\\x20f',_0x12537a['props']['unshift'](_0x15f515);}}}['_addLoadNode'](_0x5bea6e,_0x14049e){}[_0x40c820(0xeb)](_0x199084){}[_0x40c820(0x98)](_0xf50c17){var _0x35cb98=_0x40c820;return Array['isArray'](_0xf50c17)||typeof _0xf50c17==_0x35cb98(0x117)&&this['_objectToString'](_0xf50c17)===_0x35cb98(0xdc);}[_0x40c820(0x125)](_0x3ea390,_0x54c209){}[_0x40c820(0x16c)](_0x25cdb9){var _0x1aa0a5=_0x40c820;delete _0x25cdb9[_0x1aa0a5(0x136)],delete _0x25cdb9[_0x1aa0a5(0x143)],delete _0x25cdb9[_0x1aa0a5(0x138)];}['_setNodeExpressionPath'](_0x17f351,_0x40c77e){}}let _0x459cb0=new _0x1e3ba1(),_0x218fe5={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x11fc4c={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2};function _0x482c8e(_0x50675f,_0x2f7559,_0x19c481,_0x2c8a95,_0x245f16,_0x24484e){var _0x4c67af=_0x40c820;let _0x3ce9b8,_0x1af844;try{_0x1af844=_0x1169a5(),_0x3ce9b8=_0x2f8209[_0x2f7559],!_0x3ce9b8||_0x1af844-_0x3ce9b8['ts']>0x1f4&&_0x3ce9b8[_0x4c67af(0xaa)]&&_0x3ce9b8['time']/_0x3ce9b8[_0x4c67af(0xaa)]<0x64?(_0x2f8209[_0x2f7559]=_0x3ce9b8={'count':0x0,'time':0x0,'ts':_0x1af844},_0x2f8209[_0x4c67af(0xc5)]={}):_0x1af844-_0x2f8209[_0x4c67af(0xc5)]['ts']>0x32&&_0x2f8209['hits']['count']&&_0x2f8209[_0x4c67af(0xc5)][_0x4c67af(0x161)]/_0x2f8209[_0x4c67af(0xc5)]['count']<0x64&&(_0x2f8209[_0x4c67af(0xc5)]={});let _0x157126=[],_0x1464d6=_0x3ce9b8[_0x4c67af(0x112)]||_0x2f8209[_0x4c67af(0xc5)][_0x4c67af(0x112)]?_0x11fc4c:_0x218fe5,_0x553948=_0x2ff7b4=>{var _0x3a1316=_0x4c67af;let _0x5d676c={};return _0x5d676c[_0x3a1316(0x180)]=_0x2ff7b4[_0x3a1316(0x180)],_0x5d676c['elements']=_0x2ff7b4['elements'],_0x5d676c[_0x3a1316(0x126)]=_0x2ff7b4[_0x3a1316(0x126)],_0x5d676c['totalStrLength']=_0x2ff7b4['totalStrLength'],_0x5d676c['autoExpandLimit']=_0x2ff7b4[_0x3a1316(0x177)],_0x5d676c[_0x3a1316(0x115)]=_0x2ff7b4['autoExpandMaxDepth'],_0x5d676c['sortProps']=!0x1,_0x5d676c['noFunctions']=!_0x45a6b5,_0x5d676c['depth']=0x1,_0x5d676c[_0x3a1316(0xe3)]=0x0,_0x5d676c['expId']='root_exp_id',_0x5d676c[_0x3a1316(0x140)]=_0x3a1316(0x151),_0x5d676c['autoExpand']=!0x0,_0x5d676c[_0x3a1316(0x118)]=[],_0x5d676c[_0x3a1316(0x9d)]=0x0,_0x5d676c[_0x3a1316(0x168)]=!0x0,_0x5d676c['allStrLength']=0x0,_0x5d676c[_0x3a1316(0xc8)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0x5d676c;};for(var _0x33de8f=0x0;_0x33de8f<_0x245f16[_0x4c67af(0x14f)];_0x33de8f++)_0x157126[_0x4c67af(0x157)](_0x459cb0[_0x4c67af(0x14a)]({'timeNode':_0x50675f===_0x4c67af(0x161)||void 0x0},_0x245f16[_0x33de8f],_0x553948(_0x1464d6),{}));if(_0x50675f==='trace'||_0x50675f===_0x4c67af(0x184)){let _0x1d9735=Error[_0x4c67af(0xd7)];try{Error[_0x4c67af(0xd7)]=0x1/0x0,_0x157126[_0x4c67af(0x157)](_0x459cb0['serialize']({'stackNode':!0x0},new Error()['stack'],_0x553948(_0x1464d6),{'strLength':0x1/0x0}));}finally{Error[_0x4c67af(0xd7)]=_0x1d9735;}}return{'method':_0x4c67af(0xff),'version':_0x3cee70,'args':[{'ts':_0x19c481,'session':_0x2c8a95,'args':_0x157126,'id':_0x2f7559,'context':_0x24484e}]};}catch(_0x2d5a77){return{'method':_0x4c67af(0xff),'version':_0x3cee70,'args':[{'ts':_0x19c481,'session':_0x2c8a95,'args':[{'type':_0x4c67af(0xca),'error':_0x2d5a77&&_0x2d5a77[_0x4c67af(0xb4)]}],'id':_0x2f7559,'context':_0x24484e}]};}finally{try{if(_0x3ce9b8&&_0x1af844){let _0xff386f=_0x1169a5();_0x3ce9b8[_0x4c67af(0xaa)]++,_0x3ce9b8['time']+=_0x5b41b9(_0x1af844,_0xff386f),_0x3ce9b8['ts']=_0xff386f,_0x2f8209[_0x4c67af(0xc5)]['count']++,_0x2f8209[_0x4c67af(0xc5)]['time']+=_0x5b41b9(_0x1af844,_0xff386f),_0x2f8209['hits']['ts']=_0xff386f,(_0x3ce9b8[_0x4c67af(0xaa)]>0x32||_0x3ce9b8[_0x4c67af(0x161)]>0x64)&&(_0x3ce9b8['reduceLimits']=!0x0),(_0x2f8209[_0x4c67af(0xc5)][_0x4c67af(0xaa)]>0x3e8||_0x2f8209[_0x4c67af(0xc5)]['time']>0x12c)&&(_0x2f8209[_0x4c67af(0xc5)][_0x4c67af(0x112)]=!0x0);}}catch{}}}return _0x482c8e;}((_0x12a02f,_0x4ac981,_0x2c6df3,_0x42bf03,_0x1164b7,_0x296e29,_0x567fe9,_0x14adfa,_0x6b3989,_0x593945,_0x42f609)=>{var _0x543ef9=_0x418f23;if(_0x12a02f[_0x543ef9(0xdb)])return _0x12a02f[_0x543ef9(0xdb)];if(!X(_0x12a02f,_0x14adfa,_0x1164b7))return _0x12a02f[_0x543ef9(0xdb)]={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x12a02f[_0x543ef9(0xdb)];let _0x5a7d78=B(_0x12a02f),_0x236b4f=_0x5a7d78[_0x543ef9(0xd3)],_0x57b9d9=_0x5a7d78['timeStamp'],_0x163b61=_0x5a7d78[_0x543ef9(0x11b)],_0x384cd9={'hits':{},'ts':{}},_0x9c7997=J(_0x12a02f,_0x6b3989,_0x384cd9,_0x296e29),_0x3ffb36=_0xa1ec34=>{_0x384cd9['ts'][_0xa1ec34]=_0x57b9d9();},_0x4ce4d2=(_0x173258,_0x2e0c6d)=>{var _0x3b6e53=_0x543ef9;let _0x2b64c1=_0x384cd9['ts'][_0x2e0c6d];if(delete _0x384cd9['ts'][_0x2e0c6d],_0x2b64c1){let _0x557981=_0x236b4f(_0x2b64c1,_0x57b9d9());_0x593a90(_0x9c7997(_0x3b6e53(0x161),_0x173258,_0x163b61(),_0x50e896,[_0x557981],_0x2e0c6d));}},_0x46c5f3=_0x1f105e=>{var _0x1152c8=_0x543ef9,_0x4a2783;return _0x1164b7===_0x1152c8(0x110)&&_0x12a02f[_0x1152c8(0x152)]&&((_0x4a2783=_0x1f105e==null?void 0x0:_0x1f105e[_0x1152c8(0xab)])==null?void 0x0:_0x4a2783[_0x1152c8(0x14f)])&&(_0x1f105e[_0x1152c8(0xab)][0x0][_0x1152c8(0x152)]=_0x12a02f[_0x1152c8(0x152)]),_0x1f105e;};_0x12a02f[_0x543ef9(0xdb)]={'consoleLog':(_0x204f4b,_0x3e1804)=>{var _0x309615=_0x543ef9;_0x12a02f['console'][_0x309615(0xff)][_0x309615(0xb7)]!==_0x309615(0x134)&&_0x593a90(_0x9c7997(_0x309615(0xff),_0x204f4b,_0x163b61(),_0x50e896,_0x3e1804));},'consoleTrace':(_0x267a3f,_0x51c339)=>{var _0x4c4943=_0x543ef9,_0x33fd8c,_0x24e61f;_0x12a02f[_0x4c4943(0xbc)][_0x4c4943(0xff)]['name']!==_0x4c4943(0xbd)&&((_0x24e61f=(_0x33fd8c=_0x12a02f[_0x4c4943(0x104)])==null?void 0x0:_0x33fd8c['versions'])!=null&&_0x24e61f[_0x4c4943(0xc8)]&&(_0x12a02f[_0x4c4943(0x165)]=!0x0),_0x593a90(_0x46c5f3(_0x9c7997(_0x4c4943(0xc4),_0x267a3f,_0x163b61(),_0x50e896,_0x51c339))));},'consoleError':(_0xf7f1fc,_0x1384d7)=>{var _0x28d83c=_0x543ef9;_0x12a02f['_ninjaIgnoreNextError']=!0x0,_0x593a90(_0x46c5f3(_0x9c7997(_0x28d83c(0x184),_0xf7f1fc,_0x163b61(),_0x50e896,_0x1384d7)));},'consoleTime':_0x2ad865=>{_0x3ffb36(_0x2ad865);},'consoleTimeEnd':(_0x3c91cf,_0x308c8b)=>{_0x4ce4d2(_0x308c8b,_0x3c91cf);},'autoLog':(_0x4bbc9f,_0x3599a3)=>{var _0x598cfa=_0x543ef9;_0x593a90(_0x9c7997(_0x598cfa(0xff),_0x3599a3,_0x163b61(),_0x50e896,[_0x4bbc9f]));},'autoLogMany':(_0x158592,_0x29b77d)=>{var _0x425f64=_0x543ef9;_0x593a90(_0x9c7997(_0x425f64(0xff),_0x158592,_0x163b61(),_0x50e896,_0x29b77d));},'autoTrace':(_0x3f5f9d,_0xc378ab)=>{var _0x377a7d=_0x543ef9;_0x593a90(_0x46c5f3(_0x9c7997(_0x377a7d(0xc4),_0xc378ab,_0x163b61(),_0x50e896,[_0x3f5f9d])));},'autoTraceMany':(_0x2c6f73,_0x35405b)=>{var _0x4f4e7f=_0x543ef9;_0x593a90(_0x46c5f3(_0x9c7997(_0x4f4e7f(0xc4),_0x2c6f73,_0x163b61(),_0x50e896,_0x35405b)));},'autoTime':(_0x4915d6,_0xaaf0db,_0x4c1f1e)=>{_0x3ffb36(_0x4c1f1e);},'autoTimeEnd':(_0x397624,_0x436d57,_0x47b9b8)=>{_0x4ce4d2(_0x436d57,_0x47b9b8);},'coverage':_0x45a646=>{var _0x1e9860=_0x543ef9;_0x593a90({'method':_0x1e9860(0x13a),'version':_0x296e29,'args':[{'id':_0x45a646}]});}};let _0x593a90=H(_0x12a02f,_0x4ac981,_0x2c6df3,_0x42bf03,_0x1164b7,_0x593945,_0x42f609),_0x50e896=_0x12a02f[_0x543ef9(0xd8)];return _0x12a02f[_0x543ef9(0xdb)];})(globalThis,'127.0.0.1',_0x418f23(0xec),_0x418f23(0x17a),_0x418f23(0x183),'1.0.0','1751983016220',_0x418f23(0x137),_0x418f23(0x18a),_0x418f23(0x10a),_0x418f23(0xb1));");}catch(e){}};/* istanbul ignore next */function oo_oo(i:string,...v:any[]){try{oo_cm().consoleLog(i, v);}catch(e){} return v};oo_oo;/* istanbul ignore next */function oo_tr(i:string,...v:any[]){try{oo_cm().consoleTrace(i, v);}catch(e){} return v};oo_tr;/* istanbul ignore next */function oo_tx(i:string,...v:any[]){try{oo_cm().consoleError(i, v);}catch(e){} return v};oo_tx;/* istanbul ignore next */function oo_ts(v?:string):string{try{oo_cm().consoleTime(v);}catch(e){} return v as string;};oo_ts;/* istanbul ignore next */function oo_te(v:string|undefined, i:string):string{try{oo_cm().consoleTimeEnd(v, i);}catch(e){} return v as string;};oo_te;/*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/